var _style, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvoiceWithoutGst({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    id: "freepik_stories-invoice",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "svg#freepik_stories-invoice:not(.animated) .animable {opacity: 0;}svg#freepik_stories-invoice.animated #freepik--background-complete--inject-19 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) fadeIn;animation-delay: 0s;}svg#freepik_stories-invoice.animated #freepik--Plant--inject-19 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) lightSpeedRight;animation-delay: 0s;}svg#freepik_stories-invoice.animated #freepik--Desk--inject-19 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideUp;animation-delay: 0s;}svg#freepik_stories-invoice.animated #freepik--Invoice--inject-19 {animation: 6s Infinite  linear heartbeat;animation-delay: 0s;}svg#freepik_stories-invoice.animated #freepik--Character--inject-19 {animation: 1.5s Infinite  linear wind;animation-delay: 0s;}svg#freepik_stories-invoice.animated #freepik--Pencil--inject-19 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) lightSpeedRight;animation-delay: 0s;}svg#freepik_stories-invoice.animated #freepik--Calculator--inject-19 {animation: 1.5s Infinite  linear floating;animation-delay: 0s;}svg#freepik_stories-invoice.animated #freepik--speech-bubble--inject-19 {animation: 1.5s Infinite  linear heartbeat;animation-delay: 0s;}            @keyframes fadeIn {                0% {                    opacity: 0;                }                100% {                    opacity: 1;                }            }                    @keyframes lightSpeedRight {              from {                transform: translate3d(50%, 0, 0) skewX(-20deg);                opacity: 0;              }              60% {                transform: skewX(10deg);                opacity: 1;              }              80% {                transform: skewX(-2deg);              }              to {                opacity: 1;                transform: translate3d(0, 0, 0);              }            }                    @keyframes slideUp {                0% {                    opacity: 0;                    transform: translateY(30px);                }                100% {                    opacity: 1;                    transform: inherit;                }            }                    @keyframes heartbeat {                0% {                    transform: scale(1);                }                10% {                    transform: scale(1.1);                }                30% {                    transform: scale(1);                }                40% {                    transform: scale(1);                }                50% {                    transform: scale(1.1);                }                60% {                    transform: scale(1);                }                100% {                    transform: scale(1);                }            }                    @keyframes wind {                0% {                    transform: rotate( 0deg );                }                25% {                    transform: rotate( 1deg );                }                75% {                    transform: rotate( -1deg );                }            }                    @keyframes floating {                0% {                    opacity: 1;                    transform: translateY(0px);                }                50% {                    transform: translateY(-10px);                }                100% {                    opacity: 1;                    transform: translateY(0px);                }            }        ")), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-19",
    className: "animable",
    style: {
      transformOrigin: "254.255px 190.57px"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 54.12,
    y: 44.67,
    width: 172.28,
    height: 203.96,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "140.26px 146.65px"
    },
    id: "elxh3ogjfliir",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.51,
    y: 52.84,
    width: 72.75,
    height: 90.72,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "99.885px 98.2px"
    },
    id: "els3osmc0gshe",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.26,
    y: 52.84,
    width: 72.75,
    height: 90.72,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "180.635px 98.2px"
    },
    id: "elt5gbsnuior9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.51,
    y: 149.74,
    width: 72.75,
    height: 90.72,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "99.885px 195.1px"
    },
    id: "elheeipz1poqt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.26,
    y: 149.74,
    width: 72.75,
    height: 90.72,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "180.635px 195.1px"
    },
    id: "el8fswzgb3x8y",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.12,
    y: 44.67,
    width: 40.81,
    height: 291.8,
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "74.525px 190.57px"
    },
    id: "el9lbm659835b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "87.19 58.54 87.5 90.09 87.62 121.64 87.83 184.74 87.62 247.84 87.51 279.39 87.19 310.94 86.87 279.39 86.76 247.84 86.54 184.74 86.76 121.64 86.87 90.09 87.19 58.54",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "87.185px 184.74px"
    },
    id: "elm25u87vmyb9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "68.45 65.86 68.77 94.03 68.95 122.2 69.1 178.54 68.95 234.89 68.77 263.06 68.45 291.23 68.13 263.06 67.95 234.89 67.8 178.54 67.95 122.2 68.14 94.03 68.45 65.86",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "68.45px 178.545px"
    },
    id: "el3ph7261dljf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "77.82 72.51 78.14 105.5 78.25 138.48 78.47 204.46 78.25 270.43 78.14 303.42 77.82 336.4 77.5 303.42 77.39 270.43 77.17 204.46 77.39 138.48 77.5 105.5 77.82 72.51",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "77.82px 204.455px"
    },
    id: "elysor6eu1xx9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "61.48 60.2 61.8 94.73 61.91 129.25 62.13 198.3 61.91 267.35 61.8 301.88 61.48 336.4 61.17 301.88 61.05 267.35 60.84 198.3 61.05 129.25 61.17 94.73 61.48 60.2",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "61.485px 198.3px"
    },
    id: "elu6e2nl1kvbh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elpj947q3wu4k"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 185.6,
    y: 44.67,
    width: 40.81,
    height: 291.8,
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "206.005px 190.57px",
      transform: "rotate(180deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "193.33 58.54 193.65 90.09 193.76 121.64 193.98 184.74 193.76 247.84 193.65 279.39 193.33 310.94 193.02 279.39 192.9 247.84 192.69 184.74 192.9 121.64 193.02 90.09 193.33 58.54",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "193.335px 184.74px"
    },
    id: "elppdw12k1dj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "212.07 65.86 212.39 94.03 212.57 122.2 212.72 178.54 212.57 234.89 212.39 263.06 212.07 291.23 211.75 263.06 211.57 234.89 211.42 178.54 211.57 122.2 211.76 94.03 212.07 65.86",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "212.07px 178.545px"
    },
    id: "elppm1qhmkqln",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "202.7 72.51 203.02 105.5 203.13 138.48 203.35 204.46 203.13 270.43 203.02 303.42 202.7 336.4 202.38 303.42 202.27 270.43 202.06 204.46 202.27 138.48 202.39 105.5 202.7 72.51",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "202.705px 204.455px"
    },
    id: "elxzlk5ou0vnf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "219.04 60.2 219.35 94.73 219.47 129.25 219.69 198.3 219.47 267.35 219.36 301.88 219.04 336.4 218.72 301.88 218.61 267.35 218.39 198.3 218.61 129.25 218.72 94.73 219.04 60.2",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "219.04px 198.3px"
    },
    id: "eli2imfnzq20i",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-19",
    className: "animable",
    style: {
      transformOrigin: "412.274px 352.31px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394,321.68c16,15.66,18.68,39.89,15.31,61.11-.09.48-.84.35-.84-.11,0-4.83.15-9.61.13-14.39l-.24-.64c-4.18-3-8-6.46-10.39-11.16-2.68-5.26-3.73-11.18-5.77-16.67-.19-.52.37-.37.74-.1,9.73,7.18,12.83,14.9,15.62,25.22a85.9,85.9,0,0,0-1.69-16.07c-2.1-9.79-6.26-19.5-13.3-26.77C393.34,321.83,393.75,321.4,394,321.68Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "401.376px 352.341px"
    },
    id: "el0ql7re7jrmb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391,323.51c-2.75.09-4.48,4.49-6.62,5.77a2.07,2.07,0,0,1-3-.48c-2.12-3,.79-6.62,3.53-8.67-2,.81-3.58,2.22-5.7,2.63a2,2,0,0,1-2.57-1.55c-.93-4,4.14-5.84,7.62-5.92-1.69-1.18-6.52-4.36-3.95-5.93s8.27,3,10.12,4.48c2.72,2.21,6,5.51,6.09,9C396.66,326.83,393.14,324.35,391,323.51Z",
    style: {
      fill: "rgb(14, 77, 26)",
      transformOrigin: "386.526px 319.379px"
    },
    id: "eln69p9i9oiqd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el3ugpqr541e6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M391,323.51c-2.75.09-4.48,4.49-6.62,5.77a2.07,2.07,0,0,1-3-.48c-2.12-3,.79-6.62,3.53-8.67-2,.81-3.58,2.22-5.7,2.63a2,2,0,0,1-2.57-1.55c-.93-4,4.14-5.84,7.62-5.92-1.69-1.18-6.52-4.36-3.95-5.93s8.27,3,10.12,4.48c2.72,2.21,6,5.51,6.09,9C396.66,326.83,393.14,324.35,391,323.51Z",
    style: {
      opacity: 0.1,
      transformOrigin: "386.526px 319.379px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M391.82,324.18c-3.52-1.6-10.28.71-10.86-.62-1.16-2.72,4.24-4.57,7.16-4.93-2.69-.73-7.83-1.89-7.68-4.48.2-3.16,7.89-.44,11.79,2.54,4.91,3.77,4.88,7.4,4.07,8.13C395.18,325.81,392.4,324.45,391.82,324.18Z",
    style: {
      fill: "rgb(14, 77, 26)",
      transformOrigin: "388.572px 318.957px"
    },
    id: "elrn4kaubdjtr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.45,320.13c-16.58,15-20.18,39.15-17.62,60.48.07.48.82.38.84-.07.18-4.83.22-9.62.41-14.39.1-.21.18-.41.27-.63,4.29-2.87,8.26-6.15,10.81-10.76,2.87-5.15,4.15-11,6.4-16.43.21-.52-.36-.39-.74-.13-10,6.8-13.38,14.4-16.57,24.6a85.89,85.89,0,0,1,2.31-16c2.47-9.71,7-19.25,14.3-26.24C431.13,320.3,430.74,319.86,430.45,320.13Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "421.845px 350.486px"
    },
    id: "el7dnwpnz1mej",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.39,322.07c2.74.2,4.3,4.66,6.39,6a2.07,2.07,0,0,0,3.06-.36c2.23-2.88-.54-6.65-3.2-8.8,1.93.88,3.5,2.36,5.59,2.84a2,2,0,0,0,2.64-1.44c1.08-4-3.92-6-7.39-6.22,1.73-1.1,6.68-4.11,4.17-5.77s-8.38,2.67-10.29,4.1c-2.8,2.1-6.17,5.27-6.42,8.72C427.63,325.18,431.24,322.83,433.39,322.07Z",
    style: {
      fill: "rgb(14, 77, 26)",
      transformOrigin: "437.971px 318.267px"
    },
    id: "ela7hfb0jrp56",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elwaytgmnyt7m"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M433.39,322.07c2.74.2,4.3,4.66,6.39,6a2.07,2.07,0,0,0,3.06-.36c2.23-2.88-.54-6.65-3.2-8.8,1.93.88,3.5,2.36,5.59,2.84a2,2,0,0,0,2.64-1.44c1.08-4-3.92-6-7.39-6.22,1.73-1.1,6.68-4.11,4.17-5.77s-8.38,2.67-10.29,4.1c-2.8,2.1-6.17,5.27-6.42,8.72C427.63,325.18,431.24,322.83,433.39,322.07Z",
    style: {
      opacity: 0.1,
      transformOrigin: "437.971px 318.267px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M432.57,322.72c3.57-1.47,10.24,1.09,10.86-.22,1.27-2.66-4.05-4.73-6.95-5.2,2.71-.62,7.89-1.58,7.83-4.18-.07-3.17-7.87-.74-11.87,2.1-5.05,3.57-5.16,7.2-4.37,8C429.14,324.22,432,323,432.57,322.72Z",
    style: {
      fill: "rgb(14, 77, 26)",
      transformOrigin: "436.008px 317.616px"
    },
    id: "el9lry7ops7al",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.5,359.85a162,162,0,0,1-5.15,23.78.59.59,0,0,1-1.16-.23c1.09-7.33,3.08-14.52,4.17-21.85a110.82,110.82,0,0,0,1.27-22.43c-.7-12.35-4.05-25.49-12.11-35.15-.18-.23.2-.55.38-.34,16.13,18.81,13.57,41.87,13.55,43.94,2.29-7.79,4.64-16.71,13.28-24.64.37-.35.66-.18.6.4-1.54,14.44-5.56,22-13.93,29.7C414.16,355.32,413.86,357.6,413.5,359.85Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "414.405px 343.833px"
    },
    id: "elagt6dmpwmse",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.37,306.13c-2.9-1.29-6.9,2.41-9.77,2.66-1.52.14-2.65-.46-2.91-2-.71-4.15,4.15-6.48,8-7.22-2.44-.15-4.84.5-7.24-.15a2.28,2.28,0,0,1-1.89-2.89c1.07-4.67,7.23-4,10.89-2.32-1.16-2.06-4.57-7.81-1.12-8.14s7.08,7.26,8.25,9.75c1.71,3.66,3.42,8.72,1.81,12.36C404.55,312.42,402.15,308.08,400.37,306.13Z",
    style: {
      fill: "rgb(14, 77, 26)",
      transformOrigin: "396.753px 298.018px"
    },
    id: "el38ahelmq9el",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elcsb2ulkkzd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M400.37,306.13c-2.9-1.29-6.9,2.41-9.77,2.66-1.52.14-2.65-.46-2.91-2-.71-4.15,4.15-6.48,8-7.22-2.44-.15-4.84.5-7.24-.15a2.28,2.28,0,0,1-1.89-2.89c1.07-4.67,7.23-4,10.89-2.32-1.16-2.06-4.57-7.81-1.12-8.14s7.08,7.26,8.25,9.75c1.71,3.66,3.42,8.72,1.81,12.36C404.55,312.42,402.15,308.08,400.37,306.13Z",
    style: {
      opacity: 0.1,
      transformOrigin: "396.753px 298.018px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M400.86,307.24c-2.85-3.43-11-4.45-10.94-6.12.15-3.4,6.69-2.61,9.9-1.51-2.42-2.11-7.18-5.9-5.71-8.51,1.79-3.18,8.41,3.51,10.95,8.58,3.2,6.37,1.34,10.12.13,10.47C403.53,310.62,401.33,307.8,400.86,307.24Z",
    style: {
      fill: "rgb(14, 77, 26)",
      transformOrigin: "398.379px 300.239px"
    },
    id: "elxfnaxjqxavk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.11,364.2l7.12,54.36h-43.3c.89-4.82,8.95-54.43,8.95-54.43Z",
    style: {
      fill: "rgb(14, 77, 26)",
      transformOrigin: "409.58px 391.345px"
    },
    id: "el9fq1ko56juk",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Desk--inject-19",
    className: "animable animator-active",
    style: {
      transformOrigin: "250px 418.485px"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "36.71 418.48 90.03 418.24 143.35 418.15 250 417.99 356.64 418.15 409.97 418.24 463.29 418.48 409.97 418.73 356.64 418.82 250 418.98 143.35 418.82 90.03 418.73 36.71 418.48",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "250px 418.485px"
    },
    id: "el58nvhehwi3d",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Invoice--inject-19",
    className: "animable",
    style: {
      transformOrigin: "377.63px 145.395px"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 298.94,
    y: 44.67,
    width: 157.38,
    height: 201.45,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "377.63px 145.395px"
    },
    id: "elj5s5nrlgpng",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298.94,
    y: 55.95,
    width: 157.38,
    height: 11.75,
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "377.63px 61.825px"
    },
    id: "elsd8q22o6mj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "298.94 67.7 384.84 67.7 377.63 80.33 298.94 80.33 298.94 67.7",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "341.89px 74.015px"
    },
    id: "elyvxtzkm7tf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "298.94 53.62 384.84 53.62 381.3 58.27 298.94 58.27 298.94 53.62",
    style: {
      fill: "rgb(14, 77, 26)",
      transformOrigin: "341.89px 55.945px"
    },
    id: "el43qmsg5p9av",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "298.94 60.49 344.84 60.49 341.3 65.15 298.94 65.15 298.94 60.49",
    style: {
      fill: "rgb(14, 77, 26)",
      transformOrigin: "321.89px 62.82px"
    },
    id: "elkelpa3m1hwi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.59,72.6a.65.65,0,0,1,.66-.66.67.67,0,0,1,.67.66v7.07a.66.66,0,0,1-.67.66.65.65,0,0,1-.66-.66Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "395.255px 76.135px"
    },
    id: "el7a6m6w65fps",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.48,79.67a.66.66,0,0,1-.64.66.65.65,0,0,1-.66-.66v-7a.62.62,0,0,1,.26-.55.66.66,0,0,1,.91.15l3.88,5.36V72.71a.65.65,0,0,1,.64-.65.66.66,0,0,1,.66.65v7a.67.67,0,0,1-.66.66.63.63,0,0,1-.49-.24s-.05,0-.06-.07l-3.84-5.32Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "401.354px 76.1854px"
    },
    id: "elmj2erfcov3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.15,80.21l-.08-.06s0,0,0,0l-.05-.07a0,0,0,0,1,0,0,.24.24,0,0,0-.06-.09l-2.94-7a.65.65,0,0,1,.36-.85.66.66,0,0,1,.86.35L410.54,78l2.33-5.55a.66.66,0,0,1,1.23.5l-3,7a.36.36,0,0,1,0,.09s0,0,0,0l-.06.07,0,0s-.05,0-.07.06l0,0-.09.06h0l-.09,0h-.29l-.1,0h0l-.11-.08Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "410.56px 76.1331px"
    },
    id: "elqea4hfyxlyc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.56,73a4.41,4.41,0,0,1,0,6.07,3.94,3.94,0,0,1-2.87,1.28,4,4,0,0,1-2.94-1.28,4.47,4.47,0,0,1,0-6.07,4,4,0,0,1,2.94-1.28A3.9,3.9,0,0,1,422.56,73Zm-.16,3a3.05,3.05,0,0,0-.82-2.1,2.58,2.58,0,0,0-1.89-.86,2.6,2.6,0,0,0-1.94.86,3,3,0,0,0-.82,2.1,3,3,0,0,0,.82,2.08,2.54,2.54,0,0,0,3.83,0A3,3,0,0,0,422.4,76Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "419.666px 76.035px"
    },
    id: "el2xesozrlrfs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.62,72.6a.65.65,0,0,1,.66-.66.67.67,0,0,1,.67.66v7.07a.66.66,0,0,1-.67.66.65.65,0,0,1-.66-.66Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "426.285px 76.135px"
    },
    id: "el9v8c18dun8g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.82,76a4.41,4.41,0,0,1,4.41-4.32,4.55,4.55,0,0,1,2.77.93.72.72,0,0,1,.12,1,.7.7,0,0,1-1,.13,3,3,0,0,0-1.93-.66,3.16,3.16,0,0,0-2.16.87,3,3,0,0,0-.88,2.09,2.92,2.92,0,0,0,.88,2.08,3.16,3.16,0,0,0,2.16.87,3,3,0,0,0,1.93-.66A.69.69,0,0,1,436,79.4a4.49,4.49,0,0,1-2.77.93A4.4,4.4,0,0,1,428.82,76Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "432.545px 76.0051px"
    },
    id: "el4c3sn5nv0g4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.45,79.67V72.6a.65.65,0,0,1,.66-.66H443a.67.67,0,0,1,.66.66.67.67,0,0,1-.66.67h-3.25v2.19h2.79a.68.68,0,0,1,.66.66.66.66,0,0,1-.66.67h-2.79V79H443a.67.67,0,0,1,0,1.33h-3.89s0,0,0,0h0A.66.66,0,0,1,438.45,79.67Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "441.055px 76.135px"
    },
    id: "ela2weaa3pfx8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.34,
    y: 126.97,
    width: 128.58,
    height: 9.89,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "377.63px 131.915px"
    },
    id: "elwx2x08rh9u",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.34,
    y: 117.08,
    width: 128.58,
    height: 9.89,
    style: {
      fill: "rgb(14, 77, 26)",
      transformOrigin: "377.63px 122.025px"
    },
    id: "elfqqqz54roh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.34,
    y: 136.85,
    width: 128.58,
    height: 9.89,
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "377.63px 141.795px"
    },
    id: "el99rb7u30bzd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.34,
    y: 146.74,
    width: 128.58,
    height: 9.89,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "377.63px 151.685px"
    },
    id: "el6kaokj4mqc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.34,
    y: 156.63,
    width: 128.58,
    height: 9.89,
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "377.63px 161.575px"
    },
    id: "elhdhfqcfws3q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.34,
    y: 166.51,
    width: 128.58,
    height: 9.89,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "377.63px 171.455px"
    },
    id: "el81dz3adc6wl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.34,
    y: 176.4,
    width: 128.58,
    height: 9.89,
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "377.63px 181.345px"
    },
    id: "eluxrbxqvk89n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.89,
    y: 186.29,
    width: 90.03,
    height: 9.89,
    style: {
      fill: "rgb(14, 77, 26)",
      transformOrigin: "396.905px 191.235px"
    },
    id: "el9cyr2zaeb59",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.34,
    y: 117.08,
    width: 38.55,
    height: 69.21,
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "332.615px 151.685px"
    },
    id: "elunztsm01eio",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "313.34 136.85 377.63 136.73 441.92 136.85 377.63 136.98 313.34 136.85",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "377.63px 136.855px"
    },
    id: "elu8446suawdn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "313.34 146.74 377.63 146.62 441.92 146.74 377.63 146.87 313.34 146.74",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "377.63px 146.745px"
    },
    id: "el6vdz9ewu3zh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "313.34 156.63 377.63 156.5 441.92 156.63 377.63 156.75 313.34 156.63",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "377.63px 156.625px"
    },
    id: "el5xgjdnbsgcs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "313.34 166.51 377.63 166.39 441.92 166.51 377.63 166.64 313.34 166.51",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "377.63px 166.515px"
    },
    id: "elb0hq8amjzug",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "313.34 176.4 377.63 176.28 441.92 176.4 377.63 176.53 313.34 176.4",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "377.63px 176.405px"
    },
    id: "elj4jjnb6904m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "313.34 186.29 377.63 186.16 441.92 186.29 377.63 186.41 313.34 186.29",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "377.63px 186.285px"
    },
    id: "elgqch06e33mk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.23,122c4.1-.2,8.21-.22,12.31-.25s8.21,0,12.32.25c-4.11.21-8.21.22-12.32.25S324.33,122.23,320.23,122Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "332.545px 121.999px"
    },
    id: "elq6x9col0xo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.23,131.91c3.1-.21,6.21-.22,9.31-.25s6.21,0,9.32.25c-3.11.21-6.21.22-9.32.25S323.33,132.12,320.23,131.91Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "329.545px 131.909px"
    },
    id: "elote5sni954",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.23,141.8c4.1-.21,8.21-.22,12.31-.25s8.21,0,12.32.25c-4.11.21-8.21.22-12.32.25S324.33,142,320.23,141.8Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "332.545px 141.798px"
    },
    id: "elso7jd0509c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.23,151.68c3.37-.2,6.75-.22,10.13-.25s6.76,0,10.14.25c-3.38.21-6.76.22-10.14.25S323.6,151.89,320.23,151.68Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "330.365px 151.679px"
    },
    id: "elp0wc85x9l3c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.23,161.57c4.1-.21,8.21-.22,12.31-.25s8.21,0,12.32.25c-4.11.21-8.21.22-12.32.25S324.33,161.78,320.23,161.57Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "332.545px 161.569px"
    },
    id: "elxwb8h1oi5tb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.23,171.46c4.1-.21,8.21-.22,12.31-.25s8.21,0,12.32.25c-4.11.21-8.21.22-12.32.25S324.33,171.66,320.23,171.46Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "332.545px 171.458px"
    },
    id: "el44fu92sgii2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.23,181.34c2.49-.19,5-.24,7.47-.25s5,.06,7.48.25c-2.49.2-5,.24-7.48.25S322.72,181.54,320.23,181.34Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "327.705px 181.34px"
    },
    id: "eledtz1dvl4qv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.9,122c3.08-.2,6.17-.22,9.25-.25s6.18,0,9.26.25c-3.08.21-6.17.22-9.26.25S364,122.23,360.9,122Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "370.155px 121.999px"
    },
    id: "el4wfkyt9ewf2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.9,131.91c3.08-.21,6.17-.22,9.25-.25s6.18,0,9.26.25c-3.08.21-6.17.22-9.26.25S364,132.12,360.9,131.91Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "370.155px 131.909px"
    },
    id: "el7rrt1i4jish",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.9,141.8c3.08-.21,6.17-.22,9.25-.25s6.18,0,9.26.25c-3.08.21-6.17.22-9.26.25S364,142,360.9,141.8Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "370.155px 141.798px"
    },
    id: "el1zmg4652l23i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.9,151.68c3.08-.2,6.17-.22,9.25-.25s6.18,0,9.26.25c-3.08.21-6.17.22-9.26.25S364,151.89,360.9,151.68Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "370.155px 151.679px"
    },
    id: "elgl08x6jhpvv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.9,161.57c3.08-.21,6.17-.22,9.25-.25s6.18,0,9.26.25c-3.08.21-6.17.22-9.26.25S364,161.78,360.9,161.57Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "370.155px 161.569px"
    },
    id: "el8shk2mvurxc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.9,171.46c3.08-.21,6.17-.22,9.25-.25s6.18,0,9.26.25c-3.08.21-6.17.22-9.26.25S364,171.66,360.9,171.46Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "370.155px 171.458px"
    },
    id: "elyiw74fmpsol",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.9,181.34c3.08-.2,6.17-.22,9.25-.25s6.18,0,9.26.25c-3.08.21-6.17.22-9.26.25S364,181.55,360.9,181.34Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "370.155px 181.339px"
    },
    id: "elpp3ojo8win",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.65,122c3.09-.2,6.17-.22,9.26-.25s6.17,0,9.25.25c-3.08.21-6.17.22-9.25.25S390.74,122.23,387.65,122Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "396.905px 121.999px"
    },
    id: "elaefycc1ryiq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394,181.34a17.59,17.59,0,0,1,5.91,0,17.59,17.59,0,0,1-5.91,0Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "396.955px 181.34px"
    },
    id: "elrnfhhtyxd2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394,171.46a17.59,17.59,0,0,1,5.91,0,17.59,17.59,0,0,1-5.91,0Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "396.955px 171.46px"
    },
    id: "elh5958ynw6vu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394,161.57a16.43,16.43,0,0,1,3-.25,15.47,15.47,0,0,1,2.95.25,17.59,17.59,0,0,1-5.91,0Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "396.975px 161.57px"
    },
    id: "el6njigjjjq6i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394,151.68a17.59,17.59,0,0,1,5.91,0,17.59,17.59,0,0,1-5.91,0Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "396.955px 151.68px"
    },
    id: "el6wh7hkvp2ar",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394,141.8a17.59,17.59,0,0,1,5.91,0,17.59,17.59,0,0,1-5.91,0Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "396.955px 141.8px"
    },
    id: "eld7nqjcu952l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394,131.91a16.43,16.43,0,0,1,3-.25,15.47,15.47,0,0,1,2.95.25,15.47,15.47,0,0,1-2.95.25A16.43,16.43,0,0,1,394,131.91Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "396.975px 131.91px"
    },
    id: "elkm34j0iyzni",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.71,191.23a50.67,50.67,0,0,1,5.22-.25,48.07,48.07,0,0,1,5.23.25,54.73,54.73,0,0,1-10.45,0Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "400.935px 191.229px"
    },
    id: "elr99a56im0q8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.4,122c3.09-.2,6.17-.22,9.26-.25s6.17,0,9.25.25c-3.08.21-6.17.22-9.25.25S417.49,122.23,414.4,122Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "423.655px 121.999px"
    },
    id: "elpydil57yxrh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.4,131.91c3.09-.21,6.17-.22,9.26-.25s6.17,0,9.25.25c-3.08.21-6.17.22-9.25.25S417.49,132.12,414.4,131.91Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "423.655px 131.909px"
    },
    id: "elrzrmtxachcr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.4,141.8c3.09-.21,6.17-.22,9.26-.25s6.17,0,9.25.25c-3.08.21-6.17.22-9.25.25S417.49,142,414.4,141.8Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "423.655px 141.798px"
    },
    id: "elapx7cquwr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.4,151.68c3.09-.2,6.17-.22,9.26-.25s6.17,0,9.25.25c-3.08.21-6.17.22-9.25.25S417.49,151.89,414.4,151.68Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "423.655px 151.679px"
    },
    id: "eldr0pyuzf9mh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.4,161.57c3.09-.21,6.17-.22,9.26-.25s6.17,0,9.25.25c-3.08.21-6.17.22-9.25.25S417.49,161.78,414.4,161.57Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "423.655px 161.569px"
    },
    id: "el6pwwewqws68",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.4,171.46c3.09-.21,6.17-.22,9.26-.25s6.17,0,9.25.25c-3.08.21-6.17.22-9.25.25S417.49,171.66,414.4,171.46Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "423.655px 171.458px"
    },
    id: "el7mjweyjbqir",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.4,181.34c3.09-.2,6.17-.22,9.26-.25s6.17,0,9.25.25c-3.08.21-6.17.22-9.25.25S417.49,181.55,414.4,181.34Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "423.655px 181.339px"
    },
    id: "elbd1zl201t6n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.4,191.23c3.09-.21,6.17-.22,9.26-.25s6.17,0,9.25.25c-3.08.21-6.17.22-9.25.25S417.49,191.44,414.4,191.23Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "423.655px 191.229px"
    },
    id: "el3gkgl0oz2m5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.34,75c3.81-.2,7.63-.3,11.45-.38s7.63-.08,11.44-.12,7.63,0,11.45.12l5.72.14c1.91.08,3.82.13,5.73.24-1.91.12-3.82.16-5.73.25l-5.72.14c-3.82.08-7.63.07-11.45.11s-7.63,0-11.44-.11S317.15,75.22,313.34,75Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "336.235px 75.0001px"
    },
    id: "el5dsir9vw1lx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.34,70.14c4.33-.21,8.66-.31,13-.39s8.66-.07,13-.11,8.66,0,13,.11l6.5.14c2.17.08,4.34.13,6.5.25-2.16.11-4.33.16-6.5.24l-6.5.14c-4.33.08-8.66.08-13,.11s-8.67,0-13-.11S317.67,70.34,313.34,70.14Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "339.34px 70.1329px"
    },
    id: "eldz6v01jnuqq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.34,99.64c3.55-.16,7.09-.23,10.64-.29s7.1,0,10.65-.08,7.09,0,10.64.08,7.09.13,10.64.29c-3.55.16-7.09.23-10.64.29s-7.1,0-10.64.08-7.1,0-10.65-.08S316.89,99.79,313.34,99.64Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "334.625px 99.64px"
    },
    id: "elygbx5xnof1j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.34,103.85c2.22-.15,4.45-.23,6.67-.29s4.45,0,6.68-.08,4.45,0,6.67.08,4.45.14,6.68.29c-2.23.16-4.45.23-6.68.29s-4.45.06-6.67.09-4.45,0-6.68-.09S315.56,104,313.34,103.85Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "326.69px 103.844px"
    },
    id: "el9dhch12g6tp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.34,108.06c3.1-.15,6.19-.22,9.29-.28s6.19-.06,9.29-.09,6.2,0,9.29.09,6.2.13,9.29.28c-3.09.16-6.19.23-9.29.29s-6.19.06-9.29.09-6.19,0-9.29-.09S316.44,108.22,313.34,108.06Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "331.92px 108.065px"
    },
    id: "el1woqjphhyy2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.34,203.81c2.28-.16,4.55-.23,6.83-.29s4.56-.06,6.83-.09,4.56,0,6.84.09,4.55.13,6.83.29c-2.28.15-4.56.23-6.83.29s-4.56.05-6.84.08-4.55,0-6.83-.09S315.62,204,313.34,203.81Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "327.005px 203.805px"
    },
    id: "elwffgzx4vr6g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.34,208c2.63-.16,5.27-.23,7.9-.29s5.26,0,7.9-.09,5.26,0,7.9.09,5.26.13,7.9.29c-2.64.16-5.27.23-7.9.29s-5.27.05-7.9.08-5.27,0-7.9-.08S316,208.17,313.34,208Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "329.14px 207.982px"
    },
    id: "elvlwzqfale3n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.34,224.81c4.14-.15,8.28-.22,12.42-.28l12.41-.09,12.42.08c4.14.06,8.28.14,12.42.29-4.14.16-8.28.23-12.42.29l-12.42.09-12.41-.09C321.62,225,317.48,225,313.34,224.81Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "338.175px 224.815px"
    },
    id: "elh7nu2ouv4w6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.34,212.23c1.61-.15,3.21-.23,4.82-.29s3.21-.07,4.82-.08,3.21,0,4.82.08,3.21.14,4.82.29c-1.61.16-3.22.23-4.82.29s-3.22.08-4.82.09-3.22,0-4.82-.09S315,212.39,313.34,212.23Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "322.98px 212.235px"
    },
    id: "elsq47v6rk76",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394,216.39c4-.16,8-.23,12-.29l12-.09,12,.09c4,.06,8,.13,12,.29-4,.15-8,.23-12,.29l-12,.08-12-.08C402,216.62,398,216.54,394,216.39Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "418px 216.385px"
    },
    id: "el0vdvex2rynvg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394,212.23c3.25-.15,6.49-.23,9.74-.29s6.49-.05,9.74-.08,6.5,0,9.74.08,6.5.14,9.74.29c-3.24.16-6.49.23-9.74.29s-6.49.06-9.74.09-6.49,0-9.74-.09S397.2,212.39,394,212.23Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "413.48px 212.235px"
    },
    id: "eln1c2y1y4qg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394,220.6c3.05-.15,6.1-.23,9.16-.29s6.1-.05,9.15-.08,6.11,0,9.16.08,6.1.13,9.15.29c-3.05.16-6.1.23-9.15.29s-6.11.06-9.16.09-6.1,0-9.15-.09S397,220.76,394,220.6Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "412.31px 220.605px"
    },
    id: "elhvnt88y0c1w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394,224.81c2.19-.15,4.38-.22,6.56-.28s4.38-.06,6.57-.09,4.37,0,6.56.08,4.37.14,6.56.29c-2.19.16-4.37.23-6.56.29s-4.38.06-6.56.09-4.38,0-6.57-.09S396.14,225,394,224.81Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "407.125px 224.815px"
    },
    id: "elwwhznp7o0z",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.65,221.36c1.19-.82,2.42-1.6,3.68-2.32a17.55,17.55,0,0,1,4-1.79,3.53,3.53,0,0,1,.55-.1.58.58,0,0,1,.61.2,2.1,2.1,0,0,1,.25,1.12,13.22,13.22,0,0,1-.23,2.19c-.25,1.43-.61,2.84-1,4.24a65,65,0,0,1-2.88,8.21,14.11,14.11,0,0,1-1,2,3.91,3.91,0,0,1-.39.45.59.59,0,0,1-.38.17.36.36,0,0,1-.26-.1l-.13-.13a2.13,2.13,0,0,1-.31-1.16,14.64,14.64,0,0,1,.76-4.33,24.88,24.88,0,0,1,1.64-4.05,12,12,0,0,1,2.55-3.55,4,4,0,0,1,2-1,2.3,2.3,0,0,1,1.13.1,1.74,1.74,0,0,1,.8.81,4.76,4.76,0,0,0,.6.87.91.91,0,0,0,.88.3,5.74,5.74,0,0,0,1.82-1.07c.29-.22.58-.44.88-.65a2.83,2.83,0,0,1,.47-.29c.16-.07.39-.2.6,0,.29.35.21.73.36,1.05a.64.64,0,0,0,.74.48,6.49,6.49,0,0,0,1.59-1.39c.49-.53,1-1.08,1.44-1.62.95-1.1,1.88-2.21,2.85-3.29.48-.54,1-1.07,1.5-1.58.27-.25.54-.49.84-.72a2.35,2.35,0,0,1,.49-.29.76.76,0,0,1,.32-.07.44.44,0,0,1,.33.18,2,2,0,0,1,.15,1.15,9.89,9.89,0,0,1-.17,1.09c-.16.72-.36,1.42-.58,2.11a21.61,21.61,0,0,1-1.74,4,4.15,4.15,0,0,1-.68.91.79.79,0,0,1-.64.25,1.92,1.92,0,0,1-.58-.16A2.71,2.71,0,0,1,336,221.8a1,1,0,0,1,.08-.68.72.72,0,0,1,.28-.27.69.69,0,0,1,.38-.08,4.18,4.18,0,0,1,1.12.26c.7.25,1.36.54,2,.83s1.32.59,2,.85a8.63,8.63,0,0,0,1,.36,3.38,3.38,0,0,0,.49.11.7.7,0,0,0,.39-.09c.55-.27.91-.94,1.46-1.48a1.73,1.73,0,0,1,1.1-.57.59.59,0,0,1,.45.15.58.58,0,0,1,.15.44,3,3,0,0,1-.11.59c-.1.33-.14.74-.05.75s.53,0,.83,0a5.55,5.55,0,0,0,1.83-1,10.54,10.54,0,0,1,.92-.62,1.84,1.84,0,0,1,1.21-.29,4.53,4.53,0,0,1,1.86,1.35,4.67,4.67,0,0,0,.77.67c.13.08.25.11.28.08a3.4,3.4,0,0,0,.41-.26,19.19,19.19,0,0,0,1.64-1.37,19.5,19.5,0,0,0,2.8-3.23,3.63,3.63,0,0,0,.7-1.87c0-.65-.67-1-1.36-1.06a11.91,11.91,0,0,0-4.25.06,10.45,10.45,0,0,0-2.05.59,4.19,4.19,0,0,0-.91.49c-.27.2-.51.48-.43.74s.39.47.69.63.65.26,1,.4a20.5,20.5,0,0,0,2.07.6,47.49,47.49,0,0,0,8.61.83v0a45.85,45.85,0,0,1-8.67-.64,19.21,19.21,0,0,1-2.1-.58c-.35-.13-.69-.24-1-.4a1.57,1.57,0,0,1-.86-.81,1.07,1.07,0,0,1,.53-1.07,4.54,4.54,0,0,1,1-.55,10.45,10.45,0,0,1,2.11-.63,12.22,12.22,0,0,1,4.39-.12,3.23,3.23,0,0,1,1.11.37,1.36,1.36,0,0,1,.63,1.07,4.1,4.1,0,0,1-.75,2.16,17.54,17.54,0,0,1-2.86,3.33,17.83,17.83,0,0,1-1.68,1.43,3.44,3.44,0,0,1-.51.31.85.85,0,0,1-.75-.11,5.83,5.83,0,0,1-.87-.74,4.27,4.27,0,0,0-1.59-1.21c-.53-.08-1.15.42-1.72.83a6,6,0,0,1-2,1,1.62,1.62,0,0,1-1.29-.05.81.81,0,0,1-.25-.73,3.19,3.19,0,0,1,.12-.57,2.54,2.54,0,0,0,.09-.47c0-.07,0-.09,0-.07s0,0-.07,0a1.28,1.28,0,0,0-.77.41c-.49.46-.83,1.16-1.59,1.57a1.23,1.23,0,0,1-.66.13,3.18,3.18,0,0,1-.57-.13,10.82,10.82,0,0,1-1.05-.38c-.67-.28-1.33-.58-2-.87s-1.32-.58-2-.83a3.78,3.78,0,0,0-1-.24c-.23,0-.36.19-.3.5a2.3,2.3,0,0,0,1.2,1.48,1.51,1.51,0,0,0,.46.13c.09,0,.2,0,.32-.15a4,4,0,0,0,.63-.81,21.17,21.17,0,0,0,1.74-3.92,18.8,18.8,0,0,0,.6-2.07,7.69,7.69,0,0,0,.18-1,1.7,1.7,0,0,0-.08-1c-.1-.19-.51,0-.77.24a7.4,7.4,0,0,0-.81.69c-.52.49-1,1-1.51,1.55-1,1.07-1.91,2.17-2.87,3.26-.48.54-1,1.08-1.46,1.61a6.63,6.63,0,0,1-1.68,1.42.82.82,0,0,1-.93-.57c-.14-.34-.13-.77-.32-1s-.26,0-.41.06a4.21,4.21,0,0,0-.45.28c-.29.21-.57.44-.86.66a5.91,5.91,0,0,1-1.89,1.13,1.12,1.12,0,0,1-1.09-.35,5.48,5.48,0,0,1-.64-.9c-.2-.29-.39-.61-.68-.71a2.15,2.15,0,0,0-1-.07,3.84,3.84,0,0,0-1.85.91,12.08,12.08,0,0,0-2.45,3.49,25.45,25.45,0,0,0-1.57,4,14.55,14.55,0,0,0-.7,4.2,1.88,1.88,0,0,0,.23.91l.06.06h0a.25.25,0,0,0,.1-.07,2,2,0,0,0,.31-.37,14.62,14.62,0,0,0,1-1.88,62.57,62.57,0,0,0,2.95-8.13,40.23,40.23,0,0,0,1-4.2,11.77,11.77,0,0,0,.24-2.12,1.76,1.76,0,0,0-.19-1c-.09-.11-.17-.14-.36-.1a3.15,3.15,0,0,0-.52.09,18.59,18.59,0,0,0-4,1.69c-1.27.68-2.51,1.42-3.72,2.21Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "339px 224.89px"
    },
    id: "elrmq42zekuhl",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-19",
    className: "animable",
    style: {
      transformOrigin: "213.694px 296.455px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136.77,340.84a101.09,101.09,0,0,0,18.08,12.05c-8.91-16.26-4.14-50.92-3.33-45.85,3.85,24.23,18.35,51.63,24.66,53.45a.35.35,0,0,1,.11,0c17.07,3.43,33.12.64,46.81-4.71a.15.15,0,0,0,0-.08c-11.72-18.54-7.92-53.86-7.22-51.63C223.5,328,242.47,343.17,246,343.43h0c14-9.86,21.86-20.21,20.11-21.47-12.71-9.21-22.24-31-30.55-53.86h0c-8.22-22.55-11.3-55.39-23.88-75.95-11.52-18.83-37.47-24.4-53.18-16.59C117.29,196,129,334.38,136.77,340.84Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "197.709px 267.067px"
    },
    id: "eluwhxk8zc04",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.29,174.34a26.34,26.34,0,0,0-9.23,5.54,56,56,0,0,0-7.11,7.69,89.49,89.49,0,0,0-10,17.8c-5.45,12.41-8.42,37.39-9.94,50.61a207,207,0,0,0,0,39.9c.26,3.32.75,6.62,1.12,9.93l1.46,9.9,1.9,9.84,2.21,9.78-1.55-9.86-1.31-9.89-1.11-9.89c-.25-3.31-.62-6.6-.77-9.91a225.23,225.23,0,0,1,.55-39.56c1.28-13.12,4.29-37.88,9.21-50.26a90.11,90.11,0,0,1,9.26-17.82,54.56,54.56,0,0,1,6.59-7.87,35.49,35.49,0,0,1,4-3.35A18.74,18.74,0,0,1,161.29,174.34Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "142.668px 254.835px"
    },
    id: "elkdw9vam8if",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268,318.5a172.12,172.12,0,0,1-10.19-14.8c-3.19-5-6.17-10.16-8.86-15.4s-5.21-10.54-7.34-16-4.07-10.95-6.12-16.43c-4.22-10.93-8.25-33.65-13.19-44.38-2.5-5.36-5.11-10.68-8.12-15.84a80.35,80.35,0,0,0-5-7.51,22.69,22.69,0,0,0-6.7-6.34,23.63,23.63,0,0,1,6.14,6.65,79.59,79.59,0,0,1,4.47,7.66c2.76,5.22,5.15,10.58,7.42,16,4.55,10.8,8.58,33.48,12.62,44.45,2.12,5.47,4.11,10.94,6.35,16.41a141.33,141.33,0,0,0,7.75,16A166.54,166.54,0,0,0,268,318.5Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "235.24px 250.15px"
    },
    id: "elve6fxhphd0f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.92,309.83c10.76,24.17,52.86,102,78.84,106.68,17,3.06,85.15-6,96.34-22.61,4.88-7.23-5.56-56-14.6-53.77s-63.59,11.49-70.39,9.78-59.33-58-78.69-71.72C147,254.5,163.13,296.82,168.92,309.83Z",
    style: {
      fill: "rgb(235, 148, 129)",
      transformOrigin: "252.63px 344.107px"
    },
    id: "ellzp77rmbxe",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.69,337.34l4.1,73.76s-53.81,11.83-77.3,3.72c-28.51-9.85-70.24-98.17-76-112.69-9.38-23.83-6.78-38.25,6.51-34.73,5.16,1.33,12,5.4,20.28,12.73,8.71,7.64,58.74,57.21,74.53,66.57C269.68,351.94,308.69,337.34,308.69,337.34Z",
    style: {
      fill: "rgb(14, 77, 26)",
      transformOrigin: "233.346px 342.267px"
    },
    id: "elnbos6cpepi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.84,398.53a16.31,16.31,0,0,0-4.06,2.14,16.27,16.27,0,0,0,4.47-1,16,16,0,0,0,4.06-2.13A15.83,15.83,0,0,0,279.84,398.53ZM239.3,340.59a15.89,15.89,0,0,0-4.05,2.13,17.56,17.56,0,0,0,8.52-3.16A15.92,15.92,0,0,0,239.3,340.59Zm-40.9-35a16.31,16.31,0,0,0-4.06,2.14,17.64,17.64,0,0,0,8.53-3.16A16.18,16.18,0,0,0,198.4,305.58Zm29.73,79.3a16.1,16.1,0,0,0-4.06,2.13,17.56,17.56,0,0,0,8.52-3.16A15.77,15.77,0,0,0,228.13,384.88Zm47.58-28.43a16.14,16.14,0,0,0-4.06,2.14,16.27,16.27,0,0,0,4.47-1,16,16,0,0,0,4.06-2.13A15.83,15.83,0,0,0,275.71,356.45Zm-71.45-12.9a16.25,16.25,0,0,0-4,2.14,16.27,16.27,0,0,0,4.47-1,15.93,15.93,0,0,0,4-2.14A16.27,16.27,0,0,0,204.26,343.55Zm107,40.73c-.17-.68-.39-1.35-.62-2a16.31,16.31,0,0,0-2.14-4.06,15.92,15.92,0,0,0,1,4.47,16.74,16.74,0,0,0,1.84,3.66Zm-56.53,4.11a16.27,16.27,0,0,0-2.13-4.06,16.26,16.26,0,0,0,1,4.47,16,16,0,0,0,2.14,4.06A15.84,15.84,0,0,0,254.77,388.39ZM219,325.23a16.25,16.25,0,0,0-2.14-4.05,16.27,16.27,0,0,0,1,4.47A15.89,15.89,0,0,0,220,329.7,15.9,15.9,0,0,0,219,325.23Zm-39.39-38.78a16.1,16.1,0,0,0-2.13-4.06,17.56,17.56,0,0,0,3.16,8.52A15.77,15.77,0,0,0,179.56,286.45ZM235.35,407A15.84,15.84,0,0,0,231,405.6a16,16,0,0,0,3.88,2.43,16.18,16.18,0,0,0,4.38,1.36A16.16,16.16,0,0,0,235.35,407Zm49.07-30.35a16,16,0,0,0-4.38-1.35,17.87,17.87,0,0,0,8.27,3.79A16.58,16.58,0,0,0,284.42,376.61Zm-16.16,40.51a15.84,15.84,0,0,0-4.38-1.36,13.11,13.11,0,0,0,2.42,1.68l2.36-.13Zm-39.68-57.55a15.84,15.84,0,0,0-4.38-1.36,17.78,17.78,0,0,0,8.26,3.79A16,16,0,0,0,228.58,359.57Zm-60-52.07a15.84,15.84,0,0,0-4.38-1.36,16,16,0,0,0,3.88,2.43,16.18,16.18,0,0,0,4.38,1.36A16.16,16.16,0,0,0,168.6,307.5Zm37.2,64.24a15.62,15.62,0,0,0-1.35,4.38,16.21,16.21,0,0,0,2.43-3.89,16.54,16.54,0,0,0,1.36-4.38A16.26,16.26,0,0,0,205.8,371.74Zm-20-41.24a15.62,15.62,0,0,0-1.35,4.38,16.21,16.21,0,0,0,2.43-3.89,16.54,16.54,0,0,0,1.36-4.38A16.58,16.58,0,0,0,185.81,330.5Zm63.65,33.12A16.18,16.18,0,0,0,248.1,368a15.71,15.71,0,0,0,2.44-3.88,16.54,16.54,0,0,0,1.36-4.38A15.89,15.89,0,0,0,249.46,363.62Zm-94.71-77.38c.1.55.21,1.1.34,1.67a14.52,14.52,0,0,0,1-3.5A12.17,12.17,0,0,0,154.75,286.24Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "233.03px 349.935px"
    },
    id: "eluc4rdx465e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.33,410c-.94-10.88-3.13-55.55-2.95-65.24,0-.67.44-.82.52-.12,3.58,32.54,2.48,54.59,2.85,65.31C299.76,410.19,299.35,410.25,299.33,410Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "298.06px 377.171px"
    },
    id: "elj23ragb8888",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el7a9u1t4f7la"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.53,302.12c5.7,14.52,47.45,102.85,76,112.69,7,2.43,16.8,3.07,27,2.8L164.28,267c-2.83-.43-5.1.05-6.75,1.37C152.23,272.56,152.74,284.9,159.53,302.12Z",
    style: {
      opacity: 0.1,
      transformOrigin: "208.239px 342.257px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M61.67,418.39,209.41,418l-8.17-50.8s11.68-14.18,9.47-29.56c-2.42-16.85-32.81-59.57-35.36-62-10.29-9.66-21.18-11.39-31.64-7.91h0C95.38,298.17,61.67,418.39,61.67,418.39Z",
    style: {
      fill: "rgb(14, 77, 26)",
      transformOrigin: "136.329px 342.233px"
    },
    id: "eljq3a6b24j8j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.21,389.14a19.9,19.9,0,0,0-2.49,1.14l-.3.85a19.15,19.15,0,0,0,3.2-.88,15.82,15.82,0,0,0,4.06-2.14A15.92,15.92,0,0,0,73.21,389.14Zm53.38-97a16.25,16.25,0,0,0-4,2.14,16.2,16.2,0,0,0,4.46-1,15.82,15.82,0,0,0,4.06-2.14A16.27,16.27,0,0,0,126.59,292.12ZM196.3,306.5a13.53,13.53,0,0,0-2,1.22,12.29,12.29,0,0,0,2.45-.4C196.63,307.05,196.46,306.78,196.3,306.5Zm-38.06,22.11a16.27,16.27,0,0,0-4.06,2.13,17.64,17.64,0,0,0,8.53-3.16A15.92,15.92,0,0,0,158.24,328.61Zm-19,57.85a16.1,16.1,0,0,0-4.06,2.13,16.26,16.26,0,0,0,4.47-1,15.93,15.93,0,0,0,4-2.14A15.77,15.77,0,0,0,139.27,386.46Zm65-42.91a16.25,16.25,0,0,0-4,2.14,16.27,16.27,0,0,0,4.47-1,15.93,15.93,0,0,0,4-2.14A16.27,16.27,0,0,0,204.26,343.55Zm-96.94,2.58a16.21,16.21,0,0,0-4,2.13,17.56,17.56,0,0,0,8.52-3.16A15.92,15.92,0,0,0,107.32,346.13Zm72.87,38.75a16.1,16.1,0,0,0-4.06,2.13,16.26,16.26,0,0,0,4.47-1,16.08,16.08,0,0,0,4.05-2.14A15.77,15.77,0,0,0,180.19,384.88ZM141,270.57l-.3-.74c-.33.23-.65.47-1,.71.06.15.11.29.16.44A16,16,0,0,0,142,275,16.27,16.27,0,0,0,141,270.57ZM104.12,387.91a16.27,16.27,0,0,0-2.13-4.06,17.64,17.64,0,0,0,3.16,8.53A15.84,15.84,0,0,0,104.12,387.91Zm53.12-23.13a16.21,16.21,0,0,0-2.13-4,17.56,17.56,0,0,0,3.16,8.52A15.92,15.92,0,0,0,157.24,364.78Zm-18.79-49.86a16.25,16.25,0,0,0-2.14-4.05,17.93,17.93,0,0,0,3.16,8.52A16.26,16.26,0,0,0,138.45,314.92Zm65.28,84.81a15.78,15.78,0,0,0-2.13-4.06,16.26,16.26,0,0,0,1,4.47,16.08,16.08,0,0,0,2.14,4.05A15.77,15.77,0,0,0,203.73,399.73ZM179.56,286.45a16.1,16.1,0,0,0-2.13-4.06,17.56,17.56,0,0,0,3.16,8.52A15.77,15.77,0,0,0,179.56,286.45Zm-56.65,82.26a16,16,0,0,0-4.38-1.35,17.87,17.87,0,0,0,8.27,3.79A16.58,16.58,0,0,0,122.91,368.71Zm52.47,48.21a12.42,12.42,0,0,0,1.63,1.2h2.38A15,15,0,0,0,175.38,416.92ZM88.7,408.36A16.18,16.18,0,0,0,84.32,407a15.76,15.76,0,0,0,3.89,2.44,16.36,16.36,0,0,0,4.37,1.36A15.71,15.71,0,0,0,88.7,408.36Zm89.49-51.89a16,16,0,0,0-4.37-1.36,15.71,15.71,0,0,0,3.88,2.44,16.17,16.17,0,0,0,4.38,1.35A16.21,16.21,0,0,0,178.19,356.47Zm-9.59-49a15.84,15.84,0,0,0-4.38-1.36,16,16,0,0,0,3.88,2.43,16.18,16.18,0,0,0,4.38,1.36A16.16,16.16,0,0,0,168.6,307.5Zm-57.54,13.56a15.84,15.84,0,0,0-1.36,4.38,16,16,0,0,0,2.43-3.89,15.67,15.67,0,0,0,1.36-4.37A16,16,0,0,0,111.06,321.06Zm46.36,80.39a16.17,16.17,0,0,0-1.35,4.38A16,16,0,0,0,158.5,402a16.18,16.18,0,0,0,1.36-4.38A16.52,16.52,0,0,0,157.42,401.45Zm28.39-70.95a15.62,15.62,0,0,0-1.35,4.38,16.21,16.21,0,0,0,2.43-3.89,16.54,16.54,0,0,0,1.36-4.38A16.58,16.58,0,0,0,185.81,330.5Zm-63.45,75.08A16.18,16.18,0,0,0,121,410a15.71,15.71,0,0,0,2.44-3.88,16.17,16.17,0,0,0,1.35-4.38A16.16,16.16,0,0,0,122.36,405.58ZM90.28,368.81a16.08,16.08,0,0,0-1.36,4.38,17.61,17.61,0,0,0,3.79-8.27A16.21,16.21,0,0,0,90.28,368.81ZM135.46,345a15.67,15.67,0,0,0-1.36,4.37,16,16,0,0,0,2.43-3.88,16.18,16.18,0,0,0,1.36-4.38A16.21,16.21,0,0,0,135.46,345Zm18.19-56.73a15.67,15.67,0,0,0-1.36,4.37,16,16,0,0,0,2.43-3.88,16.18,16.18,0,0,0,1.36-4.38A16.21,16.21,0,0,0,153.65,288.3Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "139.565px 343.975px"
    },
    id: "el7g61e2tj19y",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.38,296.22c2.86,4.76,6,9.35,9,14-1.21-3.32-2.39-6.64-3.71-9.91a.06.06,0,0,1,.1-.06,68.94,68.94,0,0,1,5.11,12.36,93.83,93.83,0,0,1,6,11,44,44,0,0,1,4,14.46,37.12,37.12,0,0,1-2.1,14.88,96.27,96.27,0,0,1-7.48,15.76c-.38.67-1.31.05-1-.62,4.19-8.94,8.82-18.34,8.4-28.47s-5.08-19.25-9.65-27.94a138.88,138.88,0,0,0-9-15.33C190.91,296.21,191.25,296,191.38,296.22Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "201.486px 332.561px"
    },
    id: "elypnbpge2sbh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.06,407.5l-3,16.79h93.12A11.41,11.41,0,0,0,339,415.14l1.34-7.64Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "287.7px 415.895px"
    },
    id: "ele7psx6brl2q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.57,415.14l1.35-7.64h18.29l-1.35,7.64a11.39,11.39,0,0,1-10.76,9.15,7.61,7.61,0,0,1-6-2.68A7.86,7.86,0,0,1,227.57,415.14Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "237.308px 415.896px"
    },
    id: "el596b2cre09",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.32,287.76,244.25,424.29h84A11.41,11.41,0,0,0,339,415.14l24.07-136.53h-84a10.86,10.86,0,0,0-6.94,2.68A11.21,11.21,0,0,0,268.32,287.76Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "303.66px 351.45px"
    },
    id: "eler7ubt1ert",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.08,278.61l-4.86,27.58H376.48l3.25-18.43c.89-5.05-2.49-9.15-7.53-9.15Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "327.046px 292.4px"
    },
    id: "elupl5scunvze",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.32,287.76l-3.25,18.43h18.29l3.25-18.43c.89-5.05-2.48-9.15-7.53-9.15a10.86,10.86,0,0,0-6.94,2.68A11.21,11.21,0,0,0,268.32,287.76Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "275.911px 292.4px"
    },
    id: "el7ovr12af52b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.7,331.41c3.42,9.75,13.28,22.44,13.39,30.12a8.82,8.82,0,0,1-5.85,8.73s7.16,4.57,6.11,11.55c-.54,3.59-6.76,5.88-6.76,5.88s5.58,3.91,4.26,10.06c-1.05,4.9-7.12,6.46-7.12,6.46s3.6,6.25.93,10.9c-5.42,9.42-48.19,4.88-53.12-11.58-2.3-7.67,8.09-6,8.09-6s-14.36-6-13.64-14.86,14.07-5.85,14.07-5.85-13.86-5.95-12.2-15.05c1.74-9.46,14.59-4.18,14.59-4.18s-8.83-7.45-6-14.12c4.73-11,21.22,5.22,30.86,4l6.83-15Z",
    style: {
      fill: "rgb(235, 148, 129)",
      transformOrigin: "330.709px 375.684px"
    },
    id: "el8pvv6gq2ctg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.84,345.8c-2.43-9.51,10.1-19.6,9.08-29-1.37-12.75-16.7-2-21.74,15.75L343.69,347Z",
    style: {
      fill: "rgb(235, 148, 129)",
      transformOrigin: "355.335px 329.112px"
    },
    id: "eles9chtuugzw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.81,404.6a.11.11,0,0,1,0,.22c-14.44,1.94-30.88-.36-43.78-7.31-.43-.22-.24-1,.28-.85C325,401.28,338.37,404.2,353.81,404.6Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "331.856px 401.061px"
    },
    id: "eleb1naobvfpg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.79,387.8c.17,0,.16.28,0,.3-14.89,1.92-33.34-1.18-47.27-10.94-.47-.33-.57-1.11,0-.77C320.27,382.18,343.89,387.51,357.79,387.8Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "334.021px 382.473px"
    },
    id: "elqgvnl710ewk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.66,356.57c13.71,8.84,28.88,12.39,45,13.79.21,0,.16.32,0,.35-8.06,1.46-18.23-.51-26-2.71a42.85,42.85,0,0,1-19.25-10.95C312.13,356.84,312.36,356.39,312.66,356.57Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "335.041px 363.871px"
    },
    id: "el51pu0mjg2gm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.12,267.05c.2,2.6,9.66,20.71,21.2,21.94,3.76.39,6.82-20,6.82-20l.58-1.45,8-20.39-22.35-19.74-3.26-2.65s-1.81,5.72-4,12.86c-.1.33-.21.67-.31,1s-.27.78-.38,1.16c-.34,1.06-.68,2.15-1,3.24-.25.83-.49,1.63-.72,2.51s-.47,1.74-.72,2.61C152.67,256.83,151.05,266,151.12,267.05Z",
    style: {
      fill: "rgb(235, 148, 129)",
      transformOrigin: "169.419px 256.878px"
    },
    id: "elpjk069arue",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.08,237.59a43.93,43.93,0,0,0,21.64,29.92l8-20.39-22.35-19.74-3.26-2.65S160.27,230.45,158.08,237.59Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "172.9px 246.12px"
    },
    id: "elwcidhhe83qd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.28,222.84c-5.06,38.08-28.44,39.35-36.65,38.25-7.45-1-32.71-5.35-31.61-43.75s20.41-48.09,37.58-46.71S228.35,184.75,223.28,222.84Z",
    style: {
      fill: "rgb(235, 148, 129)",
      transformOrigin: "189.557px 215.915px"
    },
    id: "elc52cobewoat",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.81,218.75a25,25,0,0,1-2.44-1.06,4.22,4.22,0,0,1-2.27-1.55,1.35,1.35,0,0,1,.34-1.63,3.39,3.39,0,0,1,3.43-.11,5,5,0,0,1,2.71,2.35A1.46,1.46,0,0,1,217.81,218.75Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "216.337px 216.403px"
    },
    id: "el3af8msuywon",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.06,212.21a26,26,0,0,0,2.65,0,4.31,4.31,0,0,0,2.71-.54,1.37,1.37,0,0,0,.33-1.63,3.4,3.4,0,0,0-3.12-1.45,5,5,0,0,0-3.41,1.1A1.46,1.46,0,0,0,192.06,212.21Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "194.322px 210.41px"
    },
    id: "elef2d5wpfnsa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.12,220.59c0-.11-.22.08-.24.19-.38,2.59-1.25,5.49-3.74,5.92-.07,0-.09.15,0,.15C195.05,227,196.17,223.1,196.12,220.59Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "194.101px 223.706px"
    },
    id: "elc81jgbqvllp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.31,217.48c-4.08-1.06-5.91,7.19-2.12,8.17S197.73,218.37,194.31,217.48Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "193.13px 221.558px"
    },
    id: "el9ri0hmf4fd7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.59,217.56c-.82.31-1.71,1-2.59.87-1-.12-1.6-1.16-2.07-2.13-.05-.1-.14-.05-.16.06-.38,1.58-.13,3.33,1.52,3.94,1.49.56,2.91-.59,3.66-2.09C193.09,217.93,192.93,217.44,192.59,217.56Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "190.308px 218.345px"
    },
    id: "elp5cbhnmextp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.37,223c0-.09.17.17.14.28-.67,2.53-1,5.54,1.11,6.91.07.05,0,.17-.05.14C209.84,229.26,210.33,225.27,211.37,223Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "211.596px 226.658px"
    },
    id: "eljfrd5nwvbcn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.25,220.83c4.18.63,2.61,8.93-1.25,8.35S210.76,220.31,214.25,220.83Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "213.749px 225.008px"
    },
    id: "elasqewwdicma",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.88,221.71c.57.56,1.07,1.48,1.85,1.68s1.73-.54,2.47-1.29c.08-.08.13,0,.12.11-.26,1.6-1.1,3.15-2.68,3.17s-2.2-1.54-2.28-3.19C215.34,221.88,215.65,221.48,215.88,221.71Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "217.84px 223.511px"
    },
    id: "elk5rwxzjt1xf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.05,242.61c.45.75.83,1.73,1.73,2a7,7,0,0,0,2.88.1.09.09,0,0,1,.08.16,3.54,3.54,0,0,1-3.58.5,2.75,2.75,0,0,1-1.38-2.76C191.78,242.5,192,242.5,192.05,242.61Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "194.269px 244.086px"
    },
    id: "el71seyk0kdv4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.69,235.59s-.27,3.93-.65,5.74c0,.17-.49.15-1.11.06a.06.06,0,0,1-.07,0,8.78,8.78,0,0,1-7.66-4.94.19.19,0,0,1,.32-.2,13.14,13.14,0,0,0,7.37,3.88c.23-.47.23-6.75.52-6.71a15.79,15.79,0,0,1,3.91,1.78c.8-8.18.28-16.42,1.2-24.55a.25.25,0,0,1,.5,0c1.15,8.6.43,18-.18,26.5C208.78,238.18,205.35,236.05,204.69,235.59Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "202.406px 225.929px"
    },
    id: "elo5vvjxygso",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.7,217.83c8.8,1.8,11.44-12.11,11.44-12.11s10.17,1,14.05-14.95c0,0,2.91,10.68,16.07,15.3,2.79,1-5.38-8.33-5.38-8.33s9.49,12.67,31.65,12.88c1.56,0,4.53-23.29-10.74-34.25s-33-9.42-45.49-.86c0,0-12,4.22-15.63,15.59S154.28,217.13,157.7,217.83Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "189.563px 193.304px"
    },
    id: "ellx74sm9bhco",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187,235.2a12.75,12.75,0,1,1,16.18-12h0a12.77,12.77,0,0,1-13,12.44A12.47,12.47,0,0,1,187,235.2Zm6.41-22.92a11,11,0,1,0,8.06,10.9A11.1,11.1,0,0,0,193.44,212.28Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "190.433px 222.907px"
    },
    id: "el7e5312mrqc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216,239.58c-4.69-1.31-7.61-7.31-6.58-13.88a15.2,15.2,0,0,1,4-8.39,7.94,7.94,0,0,1,13.42,2.11,15.19,15.19,0,0,1,1.28,9.22c-1.09,6.94-6.18,11.93-11.35,11.12A5.71,5.71,0,0,1,216,239.58Zm5.14-23.18a4.42,4.42,0,0,0-.63-.14,6.83,6.83,0,0,0-5.84,2.25,13.6,13.6,0,0,0-3.57,7.45c-.94,6,1.73,11.45,6,12.12s8.46-3.69,9.41-9.7a13.6,13.6,0,0,0-1.11-8.19A7,7,0,0,0,221.09,216.4Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "218.781px 227.167px"
    },
    id: "elvhm1irismlm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.56,224.61l-.88-1.46c2.16-1.31,6.91-2.77,9.47,1l-1.41,1C207.45,221.73,202.76,224.49,202.56,224.61Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "206.415px 223.446px"
    },
    id: "eln43frc8aok",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.94,219l-1.37-1c.47-.64,4.7-6.26,8.56-6.28,3.6,0,25.83,5.65,26.78,5.89l-.43,1.65c-6.37-1.63-23.56-5.85-26.34-5.84C150.59,213.47,147.08,217.49,145.94,219Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "162.24px 215.49px"
    },
    id: "el3uqjveh2zr6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.69,221.07s-5.59-13.53-11.55-11.79-3.58,20.08,2.14,23.79a6.5,6.5,0,0,0,9.26-1.52Z",
    style: {
      fill: "rgb(235, 148, 129)",
      transformOrigin: "153.18px 221.748px"
    },
    id: "el5c0as9ccy25",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150,214.52a.09.09,0,0,0-.07.16c4,2.75,5.38,7.31,6.05,11.87-.94-1.9-2.51-3.18-5-2.12a.14.14,0,0,0,.06.26,4,4,0,0,1,4,2.32,18.46,18.46,0,0,1,1.29,3.93c.12.43.87.38.82-.1,0,0,0-.07,0-.11C158.42,225.18,155.82,216.41,150,214.52Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "153.68px 222.876px"
    },
    id: "elxf0d8lylzq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.85,269.63l-5.38,17.56-22.91-19.68-5.39,7.39s23.53,32.37,23.53,30.81l5.75-15.22,11,9.32-3-25.48Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "165.31px 286.637px"
    },
    id: "ellq8pouckxvd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.64,287.13c-.63-4.19-1.15-8.43-2-12.59,0-.14-.27-.19-.29,0-.5,4.14,2,20.15,2.32,24,0,0,0,0,0,0-.46-.41-10.12-8.16-10.2-8-1.32,2.45-5.55,13.54-5.82,14.54-3.72-5.14-19.38-25.33-23.68-30.12a.14.14,0,0,0-.24.16c3.37,5.48,23.66,32.15,23.9,32.06a165,165,0,0,0,6-16.09c1.67,1.72,11.51,10.57,11.49,9.94A131.07,131.07,0,0,0,184.64,287.13Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "165.413px 290.798px"
    },
    id: "el6cfhruo67p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.52,303c-8.9,38.34-34.11,81.23-50.07,93.84-9.72,7.67-40.83,7.74-42.22-12.39s59.69-83.22,68.68-95.49S151.56,268.41,143.52,303Z",
    style: {
      fill: "rgb(235, 148, 129)",
      transformOrigin: "98.2115px 339.97px"
    },
    id: "el9lyjw12th78",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.52,303c-8.9,38.34-34.11,81.23-50.07,93.84-9.72,7.67-40.83,7.74-42.22-12.39s59.69-83.22,68.68-95.49S151.56,268.41,143.52,303Z",
    style: {
      fill: "rgb(14, 77, 26)",
      transformOrigin: "98.2115px 339.97px"
    },
    id: "el2ysgsnufhmg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.21,389.14a16.25,16.25,0,0,0-4,2.14,16.2,16.2,0,0,0,4.46-1,15.82,15.82,0,0,0,4.06-2.14A15.92,15.92,0,0,0,73.21,389.14Zm53.38-97a16.25,16.25,0,0,0-4,2.14,16.2,16.2,0,0,0,4.46-1,15.82,15.82,0,0,0,4.06-2.14A16.27,16.27,0,0,0,126.59,292.12Zm-19.27,54a16.21,16.21,0,0,0-4,2.13,17.56,17.56,0,0,0,8.52-3.16A15.92,15.92,0,0,0,107.32,346.13ZM92.09,329A16.14,16.14,0,0,0,90,324.9a16.27,16.27,0,0,0,1,4.47,16,16,0,0,0,2.14,4.06A16.19,16.19,0,0,0,92.09,329ZM67.23,367.15a16.31,16.31,0,0,0-2.14-4.06,17.64,17.64,0,0,0,3.16,8.53A16.26,16.26,0,0,0,67.23,367.15ZM102,383.85a14,14,0,0,0,.72,3.56l.79-1A13.55,13.55,0,0,0,102,383.85Zm36.46-68.93a16.25,16.25,0,0,0-2.14-4.05,15.85,15.85,0,0,0,1,4.46,17.21,17.21,0,0,0,1.71,3.47c.08-.26.17-.51.25-.77h0A19.19,19.19,0,0,0,138.45,314.92ZM81.68,347a16.17,16.17,0,0,0-4.38-1.35,16,16,0,0,0,3.88,2.43,16.18,16.18,0,0,0,4.38,1.36A16.52,16.52,0,0,0,81.68,347Zm29.38-26a15.84,15.84,0,0,0-1.36,4.38,16,16,0,0,0,2.43-3.89,15.67,15.67,0,0,0,1.36-4.37A16,16,0,0,0,111.06,321.06ZM90.28,368.81a16.08,16.08,0,0,0-1.36,4.38,17.61,17.61,0,0,0,3.79-8.27A16.21,16.21,0,0,0,90.28,368.81ZM51.94,382.23c-.26.59-.51,1.19-.72,1.81a2.64,2.64,0,0,0,0,.4c0,.41.07.82.12,1.21A18.56,18.56,0,0,0,53,382.72a16.43,16.43,0,0,0,1.36-4.38A16,16,0,0,0,51.94,382.23Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "95.2462px 341.21px"
    },
    id: "eldgn3fc2atfu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.55,399.76a41,41,0,0,0,12.66.07,34.21,34.21,0,0,0,11.67-4.17c7.62-4.38,12.72-11.8,17.25-19.1q7.45-12,14-24.58c4.35-8.37,8.34-16.93,12.19-25.54,1.95-4.34,3.72-8.74,5.57-13.12s3.6-8.71,5.21-13.14c.41-1.12.79-2.24,1.18-3.36a.08.08,0,0,1,.16.05c-1.44,4.58-2.81,9.21-4.36,13.75-.2.59-.42,1.18-.63,1.77,1.61-3.43,3.26-6.84,5-10.21.1-.2.38,0,.3.18-1.54,3.5-3.14,7-4.78,10.41q-1.22,2.55-2.45,5.08c-.78,2.1-1.59,4.21-2.42,6.3q-5.37,13.44-11.94,26.31T111,375.67c-4.63,7.57-9.6,15.35-17.09,20.4A32.6,32.6,0,0,1,69.46,401a22.6,22.6,0,0,1-3-.86A.2.2,0,0,1,66.55,399.76Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "106.556px 349.185px"
    },
    id: "el9qm648bccja",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.43,245.88C87.78,230.43,98.08,209.24,105,206c7.28-3.37,33.35-14.17,40.22-14.72s31.23,6.57,35.63,10.89c3.51,3.46-2.58,11.7-16.46,10.52-13-1.11-16-2-19.77-1.43s-14.92,9.57-13.94,15.07c.58,3.23,8.13,8.8,14,7.79s9.4-6.75,16.65-10.1,17.65,0,17.52,3-4,3.44-11.86,11.74c-5.08,5.33-8.74,15.92-19.39,24.61-5.35,4.36-15.94,16.92-15.94,16.92Z",
    style: {
      fill: "rgb(235, 148, 129)",
      transformOrigin: "131.627px 235.77px"
    },
    id: "elwjt9gxd7c3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105,206c7.16-6.69,23.91-17.76,38.1-19.38,9.59-1.11,35.86,21.26,33.5,26.77s-7.48,4.22-14.85,1.36c-2.68-1-16-10.07-19.25-7.64-4.72,3.49-13.16,17.4-13.16,17.4Z",
    style: {
      fill: "rgb(235, 148, 129)",
      transformOrigin: "140.875px 205.545px"
    },
    id: "elorddr9smtrd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.45,211c-2.13-7.1-9.44-12.48-16.89-17.16-.12-.08-.24.1-.12.17,1.89,1.2,13.55,10.69,16.89,17.06C176.37,211.14,176.47,211.07,176.45,211Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "167.921px 202.459px"
    },
    id: "elakfkiedmvw8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105,206c7.16-6.69,23.91-17.76,38.1-19.38,9.59-1.11,28.53,23.73,26.18,29.25s-9.85,4.07-17.26-.86c-2.4-1.6-9.63-10.08-12.91-7.66-4.73,3.49-16.29,12.2-16.29,12.2Z",
    style: {
      fill: "rgb(235, 148, 129)",
      transformOrigin: "137.24px 203.067px"
    },
    id: "el1zay7vn26b9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.62,214.1c1.14-1,1.54-1.42,2.7-2.45s2.33-2,3.56-3a11.64,11.64,0,0,1,3.42-2.14,5.94,5.94,0,0,1,3.79.21c2.76,1,4.85,3.44,6.89,5.44,2.28,2.22,7.19,6.14,11.56,6.78a8.64,8.64,0,0,0,3.58,0,5.45,5.45,0,0,0,2.43-1.09c2.64-2.65,1.26-6.81-.44-10-3.18-5.84-8.2-10.77-13.2-15-1.23-1.05-2.49-2.07-3.74-3.09a13,13,0,0,0-4.78-2.81c-2.95-.78-8.56,1-10.29,1.5-.13,0-.17-.17,0-.21,2.1-.67,7.55-3.19,12.25-1.72,1.72.54,3.12,1.85,4.53,2.94s2.92,2.34,4.33,3.57a69.21,69.21,0,0,1,7.7,7.71c2.21,2.63,4.52,5.63,5.62,8.93,1,2.86.54,6.46-1.67,8.63-1.86,1.83-4.77,1.64-6.09,1.48a14.47,14.47,0,0,1-3.75-1,60.44,60.44,0,0,1-7.55-4.49c-2.32-1.69-4.2-4-6.65-5.52a5.14,5.14,0,0,0-3.92-.74,13.4,13.4,0,0,0-3.56,1.89,41.28,41.28,0,0,0-6.28,4.46C129.49,214.82,129.14,214.54,129.62,214.1Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "149.713px 202.972px"
    },
    id: "elyt7ospkmam9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.44,212c2.85-3.32,10-18.2,14.3-22.23s22.38-17.1,28.65-14.72c7.88,3-4.34,15.44-10.14,20.36s-7.71,15.35-7.71,15.35Z",
    style: {
      fill: "rgb(235, 148, 129)",
      transformOrigin: "122.2px 193.381px"
    },
    id: "el7vq8a9vni9c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.74,187c-2,1.52-3.88,3.29-5.72,5a49.12,49.12,0,0,0-5.16,5,21.52,21.52,0,0,0-3.3,6.27c-.4,1.1-.72,2.22-1,3.35s-.54,2.51-.89,3.73c0,.13.16.21.2.07a55.1,55.1,0,0,1,2.61-6.5,30,30,0,0,1,3.76-6.17c3-3.76,6.74-6.83,9.76-10.57C141.11,187.06,140.89,186.89,140.74,187Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "132.85px 198.729px"
    },
    id: "el83sox4nzm8e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.73,234.1a10.41,10.41,0,0,0,7.38-2.49c1.92-1.44,3.75-3,5.68-4.43a24.78,24.78,0,0,1,6.15-3.63,28.6,28.6,0,0,1,7.9-1.32,15.44,15.44,0,0,1,7.6,1.11c1.94.92,4,2.93,2.93,5.29a9.21,9.21,0,0,1-2.18,2.78,22.93,22.93,0,0,1-2.7,2.2c-1.91,1.37-3.94,2.6-5.72,4.16-2.37,2.08-4,4.91-5.74,7.52-.65,1-4.8,7.54-6.38,9.77a39.71,39.71,0,0,1-4.45,5.32,55.2,55.2,0,0,1-5.11,4.16,32.23,32.23,0,0,0-5.33,4.77c-.07.09-.19,0-.14-.12,2-3.68,5.66-6.15,9-8.59,4.27-3.16,13.75-19.48,15.47-21.7,2.86-3.69,7.2-5.46,10.46-8.67.75-.74,1.9-1.79,1.88-2.95a3.27,3.27,0,0,0-2-2.49c-2.24-1.19-5-1.11-7.44-.87a34,34,0,0,0-7.58,1.25,25,25,0,0,0-6.06,3.17c-2.14,1.48-4.19,3-6.44,4.34a10.49,10.49,0,0,1-7.24,1.62C141.55,234.27,141.61,234.09,141.73,234.1Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "160.634px 245.745px"
    },
    id: "elldt76aia93k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.79,200.19c-1.71-.84-3.41-1.75-5.15-2.54,0,0,0-.1,0-.08,2.06.82,4.18,1.5,6.25,2.3,1.64.63,3.33,1.55,4,3.27a4.82,4.82,0,0,1-1,4.72,12.89,12.89,0,0,1-4.52,3.06c-.09.05-.16-.09-.07-.14,2.49-1.44,6.35-4.34,4.32-7.65A8.78,8.78,0,0,0,176.79,200.19Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "176.884px 204.249px"
    },
    id: "el9fsx9zlk2j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.46,216.78c1.95.06,4.11,0,5.84-1a4.17,4.17,0,0,0,2.13-3.16,2.08,2.08,0,0,0-.19-1.41c-.08-.1.11-.19.14-.07a6.36,6.36,0,0,0,.31.76,3.32,3.32,0,0,1,.15.68,3.71,3.71,0,0,1-.11,1.37,4.44,4.44,0,0,1-1.73,2.39c-1.95,1.4-4.37,1.27-6.57.62C168.34,216.92,168.36,216.78,168.46,216.78Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "172.617px 214.256px"
    },
    id: "elty197fr9ec",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.64,280.31C127.38,295.68,95,377.65,86,389.22S55.11,403.28,49,382.37s25.7-120.85,32.42-136.49C85.17,237.18,133.17,274.74,131.64,280.31Z",
    style: {
      fill: "rgb(235, 148, 129)",
      transformOrigin: "89.9503px 321.304px"
    },
    id: "elodt963iwqq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.72,290.67,75.18,253.82S48,347.05,47.52,375.8c-.35,20.63,24.38,36.05,43.92,8.16S138.72,290.67,138.72,290.67Z",
    style: {
      fill: "rgb(14, 77, 26)",
      transformOrigin: "93.1182px 326.455px"
    },
    id: "eljf70mfucmfa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.12,255a16.71,16.71,0,0,0-2.35,3.77,16.17,16.17,0,0,0-1.35,4.38,16,16,0,0,0,2.43-3.88A16.32,16.32,0,0,0,77.19,255h0ZM56.64,343.9a16.17,16.17,0,0,0-1.35,4.38,16,16,0,0,0,2.43-3.88A16.18,16.18,0,0,0,59.08,340,16.72,16.72,0,0,0,56.64,343.9Zm-4.7,38.33a16.08,16.08,0,0,0-1.36,4.38A16,16,0,0,0,53,382.72a16.43,16.43,0,0,0,1.36-4.38A16,16,0,0,0,51.94,382.23Zm38.34-13.42a16.08,16.08,0,0,0-1.36,4.38,17.61,17.61,0,0,0,3.79-8.27A16.21,16.21,0,0,0,90.28,368.81ZM111.64,275c0,.09,0,.19,0,.28l.17-.21Zm-.58,46.09a15.84,15.84,0,0,0-1.36,4.38,16,16,0,0,0,2.43-3.89,15.67,15.67,0,0,0,1.36-4.37A16,16,0,0,0,111.06,321.06Zm-29.3-10.44A15.74,15.74,0,0,0,80.4,315a17.87,17.87,0,0,0,3.79-8.27A16.21,16.21,0,0,0,81.76,310.62Zm21.76-11.05a16.18,16.18,0,0,0-4.38-1.36,15.71,15.71,0,0,0,3.88,2.44A16.17,16.17,0,0,0,107.4,302,16.16,16.16,0,0,0,103.52,299.57ZM81.68,347a16.17,16.17,0,0,0-4.38-1.35,16,16,0,0,0,3.88,2.43,16.18,16.18,0,0,0,4.38,1.36A16.52,16.52,0,0,0,81.68,347Zm-9.5-58.58a16,16,0,0,0-4.38-1.36,17.61,17.61,0,0,0,8.27,3.79A16.21,16.21,0,0,0,72.18,288.46Zm-5,78.69a16.31,16.31,0,0,0-2.14-4.06,17.64,17.64,0,0,0,3.16,8.53A16.26,16.26,0,0,0,67.23,367.15ZM92.09,329A16.14,16.14,0,0,0,90,324.9a16.27,16.27,0,0,0,1,4.47,16,16,0,0,0,2.14,4.06A16.19,16.19,0,0,0,92.09,329Zm15.23,17.17a16.21,16.21,0,0,0-4,2.13,17.56,17.56,0,0,0,8.52-3.16A15.92,15.92,0,0,0,107.32,346.13ZM64.88,323.87a15.93,15.93,0,0,0-4,2.14,16.64,16.64,0,0,0,4.47-1,15.93,15.93,0,0,0,4-2.14A15.92,15.92,0,0,0,64.88,323.87Zm24.87-46.63a16.31,16.31,0,0,0-4.06,2.14,16.27,16.27,0,0,0,4.47-1,16,16,0,0,0,4.06-2.14A16.19,16.19,0,0,0,89.75,277.24Zm36.84,14.88a16.25,16.25,0,0,0-4,2.14,16.2,16.2,0,0,0,4.46-1,15.82,15.82,0,0,0,4.06-2.14A16.27,16.27,0,0,0,126.59,292.12Zm-53.38,97a16.25,16.25,0,0,0-4,2.14,16.2,16.2,0,0,0,4.46-1,15.82,15.82,0,0,0,4.06-2.14A15.92,15.92,0,0,0,73.21,389.14Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "90.845px 323.13px"
    },
    id: "el6zxlh4jc0ce",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130,302c-9.62-5.17-48.24-27.73-56.25-33.17-.56-.38-.45-.83.18-.51C103.17,283.08,121,296,130.22,301.59,130.45,301.73,130.28,302.11,130,302Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "101.857px 285.115px"
    },
    id: "elz9dvjpzzpz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.67,351.42c6.71-12.6,13.16-25.33,19-38.38q2.43-5.48,4.76-11c1.49-3.54,3-7.09,4.34-10.69-1.33-.93-7.17-4.75-7.8-5.34-.19-.17,0-.5.26-.42.78.29,7.56,4.22,9,5.29.21.15-2.68,7.17-4,10.53s-2.66,6.7-4.06,10q-4.16,9.87-8.8,19.51c-3.33,6.94-6.81,13.78-10.5,20.51C108.65,357.23,101,367.65,109.67,351.42Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "122.456px 322.842px"
    },
    id: "elfffitiir3jh",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pencil--inject-19",
    className: "animable",
    style: {
      transformOrigin: "321.891px 446.116px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M366.37,455.39s12.46,1.69,12.92-6.9-12.11-8.25-12.11-8.25Z",
    style: {
      fill: "rgb(221, 106, 87)",
      transformOrigin: "372.836px 447.881px"
    },
    id: "el08986pb5m75p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elnb4sjiyyb8a"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 315.54,
    y: 401.26,
    width: 15.17,
    height: 88.43,
    style: {
      fill: "rgb(14, 77, 26)",
      transformOrigin: "323.125px 445.475px",
      transform: "rotate(-86.92deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elg9z3wl99jac"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 357.13,
    y: 446.02,
    width: 17.71,
    height: 3.51,
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "365.985px 447.775px",
      transform: "rotate(-86.92deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elaciatwy1ebu"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 353.26,
    y: 445.81,
    width: 17.71,
    height: 3.52,
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "362.115px 447.57px",
      transform: "rotate(-86.92deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M279.38,435.52l-11.2,5.11-3.7,1.67,3.5,2.1,10.59,6.28,2.28-1.41-2.12-1.62,2.28-1.42-2.12-1.61,2.28-1.39s-2.08-1.61-2.11-1.65l2.28-1.38-2.12-1.65,2.28-1.38Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "272.99px 443.1px"
    },
    id: "elvqy7gd4zpkr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "268.18 440.63 264.48 442.3 267.98 444.4 268.18 440.63",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "266.33px 442.515px"
    },
    id: "elkol7u0ix1qm",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Calculator--inject-19",
    className: "animable",
    style: {
      transformOrigin: "159.665px 447.015px"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "205.82 427.46 218.77 460.9 100.56 460.9 114.69 427.5 205.82 427.46",
    style: {
      fill: "rgb(14, 77, 26)",
      transformOrigin: "159.665px 444.18px"
    },
    id: "elsc6f64dp2d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "206.76 429.89 218.77 460.9 218.77 466.57 100.56 466.57 100.56 460.9 113.67 429.92 206.76 429.89",
    style: {
      fill: "rgb(14, 77, 26)",
      transformOrigin: "159.665px 448.23px"
    },
    id: "eltgx9hoqvqpl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ellw3rapj8a0c"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "205.82 427.46 218.77 460.9 100.56 460.9 114.69 427.5 205.82 427.46",
    style: {
      opacity: 0.1,
      transformOrigin: "159.665px 444.18px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "146.38 451.9 145.64 458.33 131.28 458.33 132.66 451.9 146.38 451.9",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "138.83px 455.115px"
    },
    id: "eldwnogh0rn4n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "147.23 444.62 146.48 451.05 132.85 451.05 134.24 444.62 147.23 444.62",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "140.04px 447.835px"
    },
    id: "eljsncxmdw52b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "148.07 437.34 147.33 443.77 134.42 443.77 135.81 437.34 148.07 437.34",
    style: {
      fill: "rgb(14, 77, 26)",
      transformOrigin: "141.245px 440.555px"
    },
    id: "elch1z669f3om",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "148.92 430.06 148.17 436.48 136 436.49 137.39 430.06 148.92 430.06",
    style: {
      fill: "rgb(14, 77, 26)",
      transformOrigin: "142.46px 433.275px"
    },
    id: "el4n3x9clvy9l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "162.12 451.9 162.11 458.33 147.75 458.33 148.4 451.9 162.12 451.9",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "154.935px 455.115px"
    },
    id: "elwevq6s6bwt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "162.12 444.62 162.12 451.05 148.49 451.05 149.14 444.62 162.12 444.62",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "155.305px 447.835px"
    },
    id: "el57jtbor8w6i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "162.13 437.34 162.13 443.76 149.22 443.76 149.87 437.34 162.13 437.34",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "155.675px 440.55px"
    },
    id: "elujzwx21twb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "162.22 430.05 162.22 436.48 150.05 436.48 150.69 430.06 162.22 430.05",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "156.135px 433.265px"
    },
    id: "elb77rxkww3f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "177.85 451.9 178.58 458.33 164.22 458.33 164.13 451.9 177.85 451.9",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "171.355px 455.115px"
    },
    id: "el8vpwvjix11a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "177.02 444.62 177.75 451.04 164.12 451.05 164.03 444.62 177.02 444.62",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "170.89px 447.835px"
    },
    id: "el4guu0jzyfun",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "176.19 437.33 176.92 443.76 164.02 443.76 163.93 437.34 176.19 437.33",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "170.425px 440.545px"
    },
    id: "elplx3ba8or99",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "175.36 430.05 176.09 436.48 163.92 436.48 163.83 430.05 175.36 430.05",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "169.96px 433.265px"
    },
    id: "elcpkq8pli72v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "193.59 451.9 195.06 458.33 180.69 458.33 179.87 451.9 193.59 451.9",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "187.465px 455.115px"
    },
    id: "eltz8y0gqxjs7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "191.92 444.61 193.39 451.04 179.76 451.04 178.93 444.62 191.92 444.61",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "186.16px 447.825px"
    },
    id: "el4qt6ey5a772",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "190.25 437.33 191.72 443.76 178.82 443.76 177.99 437.33 190.25 437.33",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "184.855px 440.545px"
    },
    id: "el3zjqt6pd6dx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "188.59 430.04 190.06 436.47 177.88 436.48 177.06 430.05 188.59 430.04",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "183.56px 433.26px"
    },
    id: "elygawccb5d1r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "209.32 451.9 211.53 458.32 197.17 458.33 195.6 451.9 209.32 451.9",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "203.565px 455.115px"
    },
    id: "elt1w3u88pra",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "206.82 444.61 209.03 451.04 195.39 451.04 193.83 444.61 206.82 444.61",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "201.43px 447.825px"
    },
    id: "elpxf4b3a23yb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "204.31 437.32 206.52 443.75 193.62 443.76 192.05 437.33 204.31 437.32",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "199.285px 440.54px"
    },
    id: "eli5x8uoe3ex",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "201.81 430.04 204.02 436.47 191.85 436.47 190.28 430.04 201.81 430.04",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "197.15px 433.255px"
    },
    id: "elbp0hov6cxls",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.46,456.07h0c-.57,0-1-.18-1-.44s.56-.44,1.12-.44h0c.57,0,1,.17,1,.44S138,456.07,137.46,456.07Zm.11-.64h0c-.33,0-.61.08-.64.2s.24.2.56.2h0c.33,0,.61-.08.63-.2S137.89,455.43,137.57,455.43Zm2.68.33-3.45-1.22c-.07,0-.1-.06-.09-.1s.12-.1.24-.1l.15,0,3.46,1.23c.06,0,.09.06.09.09s-.12.11-.25.11A.33.33,0,0,1,140.25,455.76Zm-.5-.82h0c-.57,0-1-.18-1-.44s.55-.44,1.1-.44h0c.56,0,1,.18,1,.44S140.31,454.94,139.75,454.94Zm.1-.65h0c-.33,0-.61.09-.63.21s.24.2.55.2h0c.33,0,.61-.08.63-.2S140.16,454.29,139.85,454.29Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "138.655px 455.065px"
    },
    id: "eluhu2jmyynqo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.78,442.18c-1.05,0-1.82-.44-1.72-1a1,1,0,0,1,.52-.62.55.55,0,0,1,.42,0c.12.05.13.15,0,.21a.66.66,0,0,0-.36.43.46.46,0,0,0,.29.48,1.89,1.89,0,0,0,.89.2,2.26,2.26,0,0,0,.95-.2.74.74,0,0,0,.46-.48.45.45,0,0,0-.22-.43c-.08-.06-.05-.16.09-.21a.52.52,0,0,1,.41,0,.67.67,0,0,1,.32.62C142.76,441.74,141.84,442.18,140.78,442.18Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "140.941px 441.349px"
    },
    id: "el6kz8izy483c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.74,440h-3.08c-.16,0-.27-.07-.26-.15h0l.16-.86c0-.08.15-.15.31-.15s.28.07.27.15l-.13.72h1l.1-.62c0-.08.16-.15.31-.15s.28.07.27.15l-.1.62h1l.12-.72c0-.08.15-.15.31-.15s.27.07.26.15l-.13.86h0C143,440,142.89,440,142.74,440Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "141.34px 439.42px"
    },
    id: "elfx6nqvb07vv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.15,434.11c-1,0-1.7-.45-1.61-1a1,1,0,0,1,.5-.62.49.49,0,0,1,.39,0c.12.06.12.16,0,.22a.63.63,0,0,0-.35.43.51.51,0,0,0,.27.48,1.67,1.67,0,0,0,.83.19,2,2,0,0,0,.89-.19.77.77,0,0,0,.44-.48.45.45,0,0,0-.21-.43c-.07-.06,0-.16.09-.22a.43.43,0,0,1,.39,0,.66.66,0,0,1,.29.62C144,433.66,143.14,434.11,142.15,434.11Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "142.303px 433.277px"
    },
    id: "elb8z7dosx9pw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.52,454.53l3.41.67c.12,0,.19.07.19.13a.14.14,0,0,1,0,.06.58.58,0,0,1-.43.08l-3-.58,0,.69c0,.08-.16.15-.34.15s-.32-.07-.31-.15l.06-.92v0l.06-.06h.39Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "155.081px 455.13px"
    },
    id: "elk4oyn6gzho",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.1,447.25c.73,0,1.31.29,1.29.64s-.62.64-1.35.64a1.84,1.84,0,0,1-1.09-.29,1.55,1.55,0,0,1-.55.09c-.5,0-.9-.2-.89-.44s.44-.44.94-.44a1.49,1.49,0,0,1,.54.09A2,2,0,0,1,156.1,447.25Zm0,.29c-.39,0-.73.16-.74.35s.31.34.71.35.72-.16.73-.35S156.48,447.54,156.09,447.54Zm-1.68.5c.18,0,.32-.07.33-.15s-.14-.15-.31-.15-.31.07-.31.15S154.25,448,154.41,448Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "155.45px 447.891px"
    },
    id: "el11r6qs14ufqq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.23,441.23c-.71,0-1.26-.29-1.24-.65s.54-.61,1.18-.64h.31a6.32,6.32,0,0,1,1.06.09,2.14,2.14,0,0,1,.88.35.56.56,0,0,1,.23.4c0,.08-.12.15-.29.15s-.28-.06-.29-.14a.34.34,0,0,0-.14-.25,1.1,1.1,0,0,0-.36-.17l-.13,0a.38.38,0,0,1,.09.25C156.51,440.94,155.93,441.23,155.23,441.23Zm0-.29c.38,0,.7-.16.71-.36s-.29-.35-.67-.35-.69.16-.7.35S154.86,440.94,155.24,440.94Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "155.82px 440.585px"
    },
    id: "elki36pdl1h3h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.27,433.84c-.16,0-.29-.07-.29-.15l0-.84c0-.08.15-.16.31-.16s.28.08.28.16l0,.84C156.57,433.77,156.43,433.84,156.27,433.84Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "156.275px 433.265px"
    },
    id: "el98py45j8pzq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172,454.4c.18,0,.33.06.33.15v0h.44c.18,0,.32.07.33.15s-.13.15-.31.15h-.44l.06.83h0s0,.06-.07.09a.57.57,0,0,1-.45,0l-2.75-1h-.07s0,0,0,0h0v0h0v0h0l0,0h0l0,0h2.61v0C171.68,454.46,171.82,454.4,172,454.4Zm-1.73.47,1.48.53,0-.53Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "171.085px 455.108px"
    },
    id: "eliu0bbxni4tl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.2,447.48a2.15,2.15,0,0,1,1-.2,2.43,2.43,0,0,1,1,.2c.28.13.42.3.43.47h0c0,.17-.11.34-.37.47a.58.58,0,0,1-.45,0c-.13-.06-.13-.16,0-.22s.22-.16.21-.25a.37.37,0,0,0-.24-.26,1.32,1.32,0,0,0-.53-.1,1.22,1.22,0,0,0-.53.1.3.3,0,0,0-.2.26c0,.09.08.18.23.25s.14.16,0,.22l-.07,0h-.19l-1.45-.08a.44.44,0,0,1-.22-.07h0a.13.13,0,0,1,0-.07l0-.79c0-.09.13-.16.31-.16s.31.07.31.16l0,.65.55,0a.32.32,0,0,1-.06-.18C169.81,447.78,169.93,447.61,170.2,447.48Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "170.723px 447.858px"
    },
    id: "el0tp7rjnmywo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.69,439.93c.7,0,1.29.29,1.31.65s-.45.61-1.09.65h-.31a5.64,5.64,0,0,1-1.08-.1,2.18,2.18,0,0,1-.92-.34.64.64,0,0,1-.27-.4c0-.09.11-.15.27-.16s.29.06.31.14a.37.37,0,0,0,.16.26,1.36,1.36,0,0,0,.38.16l.14,0a.42.42,0,0,1-.12-.26C169.45,440.22,170,439.93,170.69,439.93Zm0,.3c-.37,0-.68.16-.67.35s.34.35.72.35.68-.15.66-.35S171.09,440.23,170.71,440.23Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "170.165px 440.58px"
    },
    id: "elt5q29ub5ii",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170,433.78c0,.08-.11.14-.25.14s-.26-.06-.27-.14l-.06-1.08c0-.07.11-.14.25-.14s.25.06.26.14Zm-1.34-.72h0c.18,0,.34.08.34.18s-.14.19-.32.19h0c-.18,0-.33-.08-.34-.19S168.47,433.06,168.65,433.06Zm2,0h0c.18,0,.33.08.33.18s-.13.19-.31.19h0c-.19,0-.34-.09-.35-.19S170.52,433.06,170.7,433.06Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "169.665px 433.24px"
    },
    id: "elqekudkbp47h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.42,454.83h3.44c.18,0,.33.07.35.15s-.11.15-.29.15H186l.15.1s.06.06.06.08,0,.1-.14.12a.57.57,0,0,1-.45,0l-.48-.33h0s0,0,0,0h0v0h0v0h0v0h0l0,0h.25Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "187.176px 455.153px"
    },
    id: "elunoxu2sgq1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.41,447.23c.18,0,.32.07.34.15l.18.95h0a.1.1,0,0,1-.08.11.61.61,0,0,1-.44,0l-1.63-.8a1.35,1.35,0,0,0-.55-.11,1.08,1.08,0,0,0-.46.09c-.15.07-.21.16-.19.26s.09.16.22.23l.17.08c.13.06.13.15,0,.21a.58.58,0,0,1-.43,0l-.17-.08a.67.67,0,0,1-.42-.43c0-.18.09-.35.36-.48a2.09,2.09,0,0,1,.86-.17,2.39,2.39,0,0,1,1,.22l1,.5-.11-.57C187.12,447.3,187.24,447.23,187.41,447.23Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "185.94px 447.856px"
    },
    id: "elpx150belnh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.14,440.17A1.84,1.84,0,0,1,185,440a2.3,2.3,0,0,1,.95.19c.28.13.44.3.47.47s-.06.34-.29.47a.51.51,0,0,1-.42,0c-.13-.06-.14-.15,0-.21a.27.27,0,0,0,.16-.26.42.42,0,0,0-.26-.25,1.1,1.1,0,0,0-.52-.11.86.86,0,0,0-.47.11c-.13.07-.18.16-.17.25s0,.08-.07.11h0a.55.55,0,0,1-.42,0l-.59-.27.07.43c0,.08-.1.15-.27.15s-.31-.07-.32-.15l-.13-.79c0-.09.11-.15.27-.15l.14,0,.08,0,.74.34A.7.7,0,0,1,184.14,440.17Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "184.573px 440.583px"
    },
    id: "elifu4q4845p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.92,432.81l.86.32.75-.32a.45.45,0,0,1,.36,0s.07.06.07.09,0,.08-.08.12l-.63.27.73.26c.07,0,.12.07.13.11s0,.06,0,.09a.41.41,0,0,1-.35,0l-.88-.32-.75.32a.45.45,0,0,1-.36,0c-.09-.07-.08-.15,0-.2l.62-.26-.71-.27c-.12-.05-.16-.14-.09-.21A.42.42,0,0,1,182.92,432.81Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "183.835px 433.281px"
    },
    id: "el6x8sqhg5f6j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.47,455c0-.11.14-.2.38-.2s.46.09.5.2-.14.2-.38.2S204.51,455.11,204.47,455Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "204.913px 455px"
    },
    id: "eli2skbmchr1b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.39,448.6a4.83,4.83,0,0,1-1.39-.18c-.38-.11-.69-.29-.75-.5s.15-.38.47-.49a3.76,3.76,0,0,1,1.27-.18,4.74,4.74,0,0,1,1.37.18c.39.11.71.29.77.49s-.15.39-.47.5A3.8,3.8,0,0,1,201.39,448.6Zm-.31-1.05a3.28,3.28,0,0,0-1,.12c-.21.08-.3.17-.27.25s.16.18.41.26a4.11,4.11,0,0,0,1,.13,3.28,3.28,0,0,0,.95-.13c.21-.08.29-.17.26-.26s-.15-.17-.42-.25A4,4,0,0,0,201.08,447.55Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "201.19px 447.925px"
    },
    id: "el66q7adfwloy",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.8,441.11c-.16,0-.32-.07-.35-.16l-.23-.82c0-.09.09-.16.25-.16s.32.07.35.16l.24.82C199.09,441,199,441.11,198.8,441.11Zm1,0c-.18,0-.34-.07-.36-.16l-.25-.82c0-.09.1-.16.27-.16s.33.07.35.16l.25.82C200.07,441,200,441.11,199.78,441.11Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "199.14px 440.54px"
    },
    id: "el3dn9jxz3mmg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.19,433.39l.12.38c0,.08-.08.14-.23.14s-.3-.06-.32-.14l-.11-.38H196c-.15,0-.3-.07-.32-.15s.08-.16.24-.16h.68l-.11-.38c0-.08.08-.15.23-.15s.29.07.31.15l.11.38h.69a.36.36,0,0,1,.33.15c0,.09-.08.16-.24.16Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "196.919px 433.23px"
    },
    id: "elq5mnii5ra6f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.48,446.92c.13,0,.23.05.22.11l-.06.34c.78.14,2.82.49,3.41.57a.54.54,0,0,1,.18.06.08.08,0,0,1,.05.08s0,.07-.11.1-.78.36-1.06.47-.55.09-.58.07,0,0,0-.06,0-.07.09-.1l.27-.12.22-.1.21-.09.22-.1-3.22-.56h0l-.08,0s-.07-.06-.06-.09l.08-.44C138.24,447,138.36,446.92,138.48,446.92Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "140.23px 447.828px"
    },
    id: "elw13ndem3xn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "130.68 430.06 122.92 458.33 107.8 458.33 118.54 430.07 130.68 430.06",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "119.24px 444.195px"
    },
    id: "elo31lkmhqq2i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.73,442.83H123c.28,0,.46.11.42.25s-.29.24-.57.24h-4.39l.14.18a.13.13,0,0,1,0,.13.48.48,0,0,1-.32.21.71.71,0,0,1-.65-.09l-.46-.54s0,0,0,0l0,0v0s0,0,0,0,0,0,0,0h0v0s0,0,0,0l0,0,0,0s0,0,0,0l0,0h0l0,0,0,0h.32Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "120.298px 443.356px"
    },
    id: "el7h5642hiybg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.78,440.24c.27,0,.44.11.4.25l-.48,1.58h0a.39.39,0,0,1-.21.18.9.9,0,0,1-.69,0l-1.94-1.33a1.39,1.39,0,0,0-.78-.18,2.42,2.42,0,0,0-.81.14.87.87,0,0,0-.52.43.32.32,0,0,0,.16.39l.2.14c.15.1.08.25-.15.35a.85.85,0,0,1-.69,0l-.2-.14a.59.59,0,0,1-.29-.72,1.58,1.58,0,0,1,1-.79,4,4,0,0,1,1.5-.28,2.63,2.63,0,0,1,1.43.35l1.24.85.29-.95C123.26,440.35,123.51,440.24,123.78,440.24Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "120.967px 441.279px"
    },
    id: "elr5j2yhm3kr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.32,437.93a4,4,0,0,1,1.6-.32,2.71,2.71,0,0,1,1.4.32.68.68,0,0,1,.39.79,1.48,1.48,0,0,1-.87.78.83.83,0,0,1-.69,0c-.16-.1-.11-.26.11-.36a.79.79,0,0,0,.47-.42.37.37,0,0,0-.2-.43,1.51,1.51,0,0,0-.77-.18,2.12,2.12,0,0,0-.87.18.92.92,0,0,0-.49.42c0,.08-.09.14-.21.19h0a.87.87,0,0,1-.69,0l-.74-.45-.25.72c0,.14-.31.25-.58.25s-.45-.11-.4-.25l.46-1.32c0-.14.31-.25.57-.25a.69.69,0,0,1,.22,0l.11,0,.92.57A2,2,0,0,1,121.32,437.93Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "121.626px 438.583px"
    },
    id: "eld51xeovct9a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.45,434.51c.26,0,.42.11.38.25l0,.05h.64c.26,0,.42.1.38.24s-.27.25-.53.25h-.64l-.44,1.4h0a.28.28,0,0,1-.15.16.81.81,0,0,1-.66,0l-3.33-1.65h0l0,0s0,0,0,0l0,0a0,0,0,0,1,0,0s0,0,0,0,0,0,0,0v-.05h0v0l0,0,0,0v0l0,0,0,0a0,0,0,0,1,0,0h0l0,0h0l0,0h3.62v-.05C124,434.63,124.2,434.51,124.45,434.51Zm-2.78.79,1.78.89.29-.89Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "122.978px 435.72px"
    },
    id: "elkh4o3e9v17r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.21,432.29a3.67,3.67,0,0,1,1.54-.33,2.5,2.5,0,0,1,1.32.33.66.66,0,0,1,.36.78h0a1.41,1.41,0,0,1-.84.78.76.76,0,0,1-.66,0c-.15-.1-.1-.26.11-.36a.78.78,0,0,0,.46-.43.35.35,0,0,0-.19-.42,1.33,1.33,0,0,0-.72-.18,2,2,0,0,0-.84.18.77.77,0,0,0-.46.42.35.35,0,0,0,.18.43c.15.1.09.26-.12.36l-.12.05h-.29l-2.1-.13a.46.46,0,0,1-.29-.12h0s0,0,0,0a.09.09,0,0,1,0-.11l.46-1.32c0-.14.29-.25.55-.25s.42.11.37.25l-.38,1.1.8.05a.77.77,0,0,1,0-.3A1.49,1.49,0,0,1,123.21,432.29Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "123.493px 432.942px"
    },
    id: "ell4l0u69mjlc",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-19",
    className: "animable",
    style: {
      transformOrigin: "258.48px 151.692px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M293.67,151.68a33.38,33.38,0,0,1-53.28,26.81L224,182.66l6.81-15.23a33.39,33.39,0,1,1,62.82-15.75Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "258.835px 151.669px"
    },
    id: "elnjxwzit2rht",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.67,151.68a33.56,33.56,0,0,1-4.95,17.53,37.61,37.61,0,0,1-2.65,3.77,37.2,37.2,0,0,1-3.19,3.33c-.59.5-1.11,1.08-1.74,1.52l-1.85,1.39c-.61.46-1.3.83-1.94,1.24l-1,.61c-.33.19-.69.35-1,.52l-2.08,1-2.17.81a15.23,15.23,0,0,1-2.21.67c-.75.18-1.49.44-2.25.55a32.46,32.46,0,0,1-4.6.56,28.63,28.63,0,0,1-4.63,0,33.46,33.46,0,0,1-17.21-6.41l.3.06-16.33,4.26-.88.23.37-.84,6.77-15.24v.42a33.07,33.07,0,0,1-4-14.71,33.76,33.76,0,0,1,12.11-27.08,33.81,33.81,0,0,1,28.68-7,34,34,0,0,1,13.62,6.47A33.54,33.54,0,0,1,293.67,151.68Zm0,0a33.47,33.47,0,0,0-12.91-26.24,33.92,33.92,0,0,0-13.6-6.25,33.26,33.26,0,0,0-14.92.41A32.83,32.83,0,0,0,239,126.44a34.41,34.41,0,0,0-8.86,11.91,33,33,0,0,0,1.1,28.86l.11.21-.09.21-6.85,15.21-.51-.6,16.38-4.1.16,0,.14.1a33,33,0,0,0,16.82,6.51,29.06,29.06,0,0,0,4.57.07,33.13,33.13,0,0,0,4.55-.49c.76-.11,1.49-.35,2.24-.52a15.37,15.37,0,0,0,2.2-.64l2.16-.77,2.07-1c.35-.17.7-.32,1-.5l1-.59c.65-.41,1.34-.76,1.95-1.21l1.85-1.37a20.8,20.8,0,0,0,1.74-1.5,38.35,38.35,0,0,0,3.2-3.3,36.33,36.33,0,0,0,2.66-3.75A33.48,33.48,0,0,0,293.67,151.68Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "258.48px 151.692px"
    },
    id: "elmmzyf59e21",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "256.67 169.3 244.24 156.73 248.42 152.61 255.67 159.95 270.75 136.32 275.69 139.47 256.67 169.3",
    style: {
      fill: "rgb(14, 77, 26)",
      transformOrigin: "259.965px 152.81px"
    },
    id: "elx42zab62099",
    className: "animable"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "active",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#32DFEC",
    floodOpacity: 1,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "hover",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ff0000",
    floodOpacity: 0.5,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0   0   0   0   0                0   1   0   0   0                0   0   0   0   0                0   0   0   1   0 "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoiceWithoutGst);
export default __webpack_public_path__ + "static/media/InvoiceWithoutGST.002a3acc.svg";
export { ForwardRef as ReactComponent };